import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import {
  getDataEndPoint,
  updateDataEndPoint,
  getReportingDataEndPoint,
  getSegmentGeoHashInfoApiUrl,
} from "app/utils/constants/paths";
import uuid from "react-uuid";
import { toast } from "react-toastify";
import { joinPaths } from "@remix-run/router";
import axiosApiInstance from "app/services/axios";
import { addslashes, AudienceCrmsAssocData } from "app/utils/utils";
import cloneDeep from "lodash.clonedeep";
import { DATASOURCE_CONFIG } from "app/config";
import moment from "moment";

const initialState = {
  loading: false,
  submitLoading: false,
  statesLoading: false,
  targetingTypesAndOption: [],
  targetingTypesOptions: {},
  countriesList: [],
  statesList: {},
  countryStatesList: [],
  audienceSegmentsList: [],
  activeStatus: "",
  CityStateDMAList: [],
  TargetStatesList: [],
  DMAList: [],
  POIList: [],
  POILocationsList: [],
  POIChainNamesList: [],
  POIDataList: {},

  AttrLocationsList: [],
  AttrChainNamesList: [],
  AttrDataList: {},

  BrandsList: [],
  KMLList: [],
  CongressionalDistrictsList: [],
  SenateDistrictsList: [],
  HouseDistrictsList: [],
  CountiesList: [],
  CategoriesList: [],
  PublishersList: [],
  PlacementIdsList: [],
  SupplyDealIdsList: [],
  BundleIdsList: [],
  searchLoading: false,
  searchPOILoading: false,
  searchAttrLoading: false,

  isCountriesLoaded: false,
  isCategoriesLoaded: false,
  providersList: [],
  providerFlag: false,
  segmentFilterFormValues: {
    accounts: [],
    segmenttypes: [],
  },
  segmentFilters: {
    accounts: [],
    segmenttypes: [],
  },
  ContextualCategoriesList: [],
  contextualFlag: false,
};

export const CreateSegmentThunk = createAsyncThunk(
  "audienceManagement/CreateSegmentThunk",
  async (payload) => {
    const formInfo = payload.formInfo;
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    const queryBody = {
      queries: [
        {
          query:
            "insert into " +
            tablePrefix +
            "audience_segments_providers (id,segment_name,is_active,customsegment_accountid,segment_data,created_at,updated_at) values('" +
            uuid() +
            "','" +
            formInfo.name +
            "','" +
            formInfo.isEnableSegment +
            "','" +
            payload.account_id +
            "','" +
            JSON.stringify(formInfo.locations) +
            "'," +
            DATASOURCE_CONFIG.CURRENT_DATE +
            "," +
            DATASOURCE_CONFIG.CURRENT_DATE +
            ")",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetAllTargetingTypesAndOptions = createAsyncThunk(
  "audienceManagement/GetAllTargetingTypesAndOptions",
  async (payload) => {
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, payload);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetAllCountriesListThunk = createAsyncThunk(
  "audienceManagement/GetAllCountriesListThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    const queryBody = {
      queries: [
        {
          query:
            "select name,iso3 as id,iso2,latitude as lat,longitude as lng from " +
            tablePrefix +
            "countries",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetAllStateListThunk = createAsyncThunk(
  "audienceManagement/GetAllStateListThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    var country = payload.cc;
    var query = payload.q;

    let stateWhere = "";

    let selStates = [];
    var selectedValuesArr = payload?.selValue ? payload?.selValue : [];
    for (let x = 0; x < selectedValuesArr.length; x++) {
      let info = selectedValuesArr[x];
      if (info.type == "state") {
        selStates.push(info.id);
      }
    }

    stateWhere =
      selStates.length > 0
        ? " and CONCAT(c.iso3, '_', s.`iso2`) NOT IN('" +
          selStates.join("','") +
          "')"
        : "";
    let stateQuery = "";
    if (DATASOURCE_CONFIG.DATASOURCE == "mysql") {
      /***State* */
      stateQuery =
        "SELECT CONCAT(c.iso3, '_', s.`iso2`) AS id,CONCAT(s.name,' [',s.iso2,']',' (STATE)') AS name, s.latitude AS lat, s.longitude AS lng,'state' AS type from " +
        tablePrefix +
        "states s,countries c  WHERE s.country_code = '" +
        country +
        "' AND s.`country_code`=c.iso2 AND (s.name " +
        DATASOURCE_CONFIG.QUERY_LIKE +
        " '%" +
        query +
        "%'  OR s.iso2 like '%" +
        query +
        "%' ) " +
        stateWhere +
        " limit 5;";
      /***CITY* */
    } else {
      // For Redshift database

      /**** */
      stateQuery =
        "SELECT CONCAT(c.iso3, '_', s.`iso2`) AS id,concat(s.name,' (STATE)') as name, s.latitude as lat, s.longitude as lng,'state' as type from " +
        tablePrefix +
        "FROM states s,countries c WHERE s.country_code= '" +
        country +
        "' and s.country_code=c.iso2 and s.name " +
        DATASOURCE_CONFIG.QUERY_LIKE +
        " '%" +
        query +
        "%'  and len(iso2) = 2 " +
        stateWhere +
        "  limit 5;";
      /*** */
    }
    const queryBody = {
      queries: [],
    };

    queryBody.queries.push(
      //state
      {
        query: stateQuery,
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      }
    );
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetAllDMAListThunk = createAsyncThunk(
  "audienceManagement/GetAllDMAListThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    var country = payload.cc;
    var query = payload.q;

    let dmaWhere = "";
    let selDMAs = [];
    var selectedValuesArr = payload?.selValue ? payload?.selValue : [];
    for (let x = 0; x < selectedValuesArr.length; x++) {
      let info = selectedValuesArr[x];
      if (info.type == "dma") {
        selDMAs.push(info.id);
      }
    }

    dmaWhere =
      selDMAs.length > 0
        ? " and dma_code NOT IN('" + selDMAs.join("','") + "')"
        : "";

    var DMAQuery = "";
    if (DATASOURCE_CONFIG.DATASOURCE == "mysql") {
      DMAQuery =
        "select dma_code,dma_code as id, concat(dma_name,' (DMA)') as name,0 as lat,0 as lng,'dma' as type from " +
        tablePrefix +
        "geodma where country_code = '" +
        country +
        "' and concat(dma_name,' (DMA)') " +
        DATASOURCE_CONFIG.QUERY_LIKE +
        " '%" +
        query +
        "%' " +
        dmaWhere +
        " limit 5;";
    } else {
      // For Redshift database
      DMAQuery =
        "select dma_code,dma_code as id, concat(dma_name,' (DMA)') as name,0 as lat,0 as lng,'dma' as type from " +
        tablePrefix +
        "geodma where country_code = '" +
        country +
        "' and concat(dma_name,' (DMA)') " +
        DATASOURCE_CONFIG.QUERY_LIKE +
        " '%" +
        query +
        "%' " +
        dmaWhere +
        " limit 5;";
      /**** */
    }
    const queryBody = {
      queries: [],
    };

    if (country === "US") {
      //dma
      var dma = {
        query: DMAQuery,
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      };
      queryBody.queries.push(dma);
    }

    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetAllCityStateDMAListThunk = createAsyncThunk(
  "audienceManagement/GetAllCityStateDMAListThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    var country = payload.cc;
    var query = payload.q;

    let cityWhere = "";

    let selCities = [];
    var selectedValuesArr = payload?.selValue ? payload?.selValue : [];
    for (let x = 0; x < selectedValuesArr.length; x++) {
      let info = selectedValuesArr[x];
      if (info.type == "city") {
        selCities.push(info.id);
      }
    }

    cityWhere =
      selCities.length > 0
        ? " and CONCAT(CONCAT(c.iso3, '_', s.`state_code`),'_',s.name) NOT IN('" +
          selCities.join("','") +
          "')"
        : "";
    // dmaWhere =
    //   selDMAs.length > 0
    //     ? " and dma_code NOT IN('" + selDMAs.join("','") + "')"
    //     : "";

    let cityQuery = "";
    if (DATASOURCE_CONFIG.DATASOURCE == "mysql") {
      cityQuery =
        "SELECT CONCAT(CONCAT(c.iso3, '_', s.`state_code`),'_',s.name) AS id,s.latitude AS lat, s.longitude AS lng,concat(concat((s.name), ' ', s.state_code), ' (CITY)') as name,'city' AS type from " +
        tablePrefix +
        "cities s,countries c  WHERE s.country_code = '" +
        country +
        "' AND s.`country_code`=c.iso2 AND s.name " +
        DATASOURCE_CONFIG.QUERY_LIKE +
        " '%" +
        query +
        "%' " +
        cityWhere +
        " limit 5;";
    } else {
      cityQuery =
        "select concat(concat(concat(concat(country_code, '_'), state_code), '_'), name),id, latitude as lat, longitude as lng, concat(concat(concat((name), ' '), state_code), ' (CITY)') as name,'city' as type from " +
        tablePrefix +
        "cities where country_code = '" +
        country +
        "' and name " +
        DATASOURCE_CONFIG.QUERY_LIKE +
        " '%" +
        query +
        "%'  " +
        cityWhere +
        "  limit 5;";
    }
    const queryBody = {
      queries: [],
    };

    queryBody.queries.push(
      //city
      {
        query: cityQuery,
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      }
    );

    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetAllPOIListThunk = createAsyncThunk(
  "audienceManagement/GetAllPOIListThunk",
  async (payload) => {
    var country = payload.cc;
    var searchText = payload.q;

    let Where = "";
    let selPOI = [];
    var selectedValuesArr = payload?.selValue ? payload?.selValue : [];
    for (let x = 0; x < selectedValuesArr.length; x++) {
      let info = selectedValuesArr[x];
      if (info?.id) {
        selPOI.push(info.id);
      }
    }

    Where =
      selPOI.length > 0 ? " and id NOT IN('" + selPOI.join("','") + "')" : "";

    const queryBody = {
      queries: [
        /*{
          query:
            "select id as brand_id,id, name as brand,location_count from aggdata.lists where country_code = '" +
            country +
            "' and name "+DATASOURCE_CONFIG.QUERY_LIKE+" '%" +
            query +
            "%' limit 5;",
          datasource: "redshift",
        },*/
        {
          query:
            "select ((chain_name) || ', ' || store_name || ', ' || city_name || ', ' || region_code) as full_name,id,chain_name,store_name,city_name,region_code,latitude as lat,longitude as lng,postal_code  from mn.mn_places where full_name " +
            DATASOURCE_CONFIG.QUERY_LIKE +
            " '%" +
            searchText +
            "%' and country_code='" +
            country +
            "' and permanently_closed=0 " +
            Where +
            " order by id limit 5",
          datasource: "redshift",
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        getReportingDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetAllCountiesListThunk = createAsyncThunk(
  "audienceManagement/GetAllCountiesListThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    var country = payload.cc;
    var query = payload.q;

    let countiesWhere = "";
    let selCounties = [];
    var selectedValuesArr = payload?.selValue ? payload?.selValue : [];
    for (let x = 0; x < selectedValuesArr.length; x++) {
      let info = selectedValuesArr[x];
      if (info?.county_code) {
        selCounties.push(info.county_code);
      }
    }

    countiesWhere =
      selCounties.length > 0
        ? " and id NOT IN('" + selCounties.join("','") + "')"
        : "";

    let countiesQuery = "";
    if (DATASOURCE_CONFIG.DATASOURCE == "mysql") {
      countiesQuery =
        "select id as county_code, CONCAT(CONCAT(county_name, ' [', state_name), ']',CONCAT('[',id, ']')) as name from " +
        tablePrefix +
        "counties where country_code = 'US' and CONCAT(CONCAT(county_name, ' [', state_name), ']',CONCAT('[',id, ']')) " +
        DATASOURCE_CONFIG.QUERY_LIKE +
        " '%" +
        query +
        "%' " +
        countiesWhere +
        " limit 5;";
    } else {
      // For Redshift database
      countiesQuery =
        "select id as county_code, concat(concat(county_name, ' '), state_name) as name from " +
        tablePrefix +
        "counties where country_code = 'US' and concat(concat(county_name, ' '), state) " +
        DATASOURCE_CONFIG.QUERY_LIKE +
        " '%" +
        query +
        "%' " +
        countiesWhere +
        " limit 5;";
    }
    const queryBody = {
      queries: [
        {
          query: countiesQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetAllBrandsListThunk = createAsyncThunk(
  "audienceManagement/GetAllBrandsListThunk",
  async (payload) => {
    var country = payload.cc;
    var query = payload.q;
    let brandsWhere = "";
    let selbrands = [];
    var selectedValuesArr = payload?.selValue ? payload?.selValue : [];
    for (let x = 0; x < selectedValuesArr.length; x++) {
      let info = selectedValuesArr[x];
      if (info?.id) {
        selbrands.push(info.id);
      }
    }

    brandsWhere =
      selbrands.length > 0
        ? " and id NOT IN('" + selbrands.join("','") + "')"
        : "";
    const queryBody = {
      queries: [
        {
          query:
            "select id as brand_id,id, name,location_count from aggdata.lists where country_code = '" +
            country +
            "' and name ilike '%" +
            query +
            "%' " +
            brandsWhere +
            " limit 5;",
          datasource: "redshift",
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetAllCongressionalDistrictsListThunk = createAsyncThunk(
  "audienceManagement/GetAllCongressionalDistrictsListThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    var country = payload.cc;
    let congWhere = "";
    let selCongs = [];
    var selectedValuesArr = payload?.selValue ? payload?.selValue : [];
    for (let x = 0; x < selectedValuesArr.length; x++) {
      let info = selectedValuesArr[x];
      if (info?.id) {
        selCongs.push(info.id);
      }
    }

    congWhere =
      selCongs.length > 0
        ? " and dm.id NOT IN('" + selCongs.join("','") + "')"
        : "";
    var query = payload.q;
    let CongQry =
      "SELECT dm.id AS id,concat(concat(state_code, '-'), cd116_fip) AS name,cn.iso3 as country_code_iso3,0 as lat,0 as lng FROM " +
      tablePrefix +
      "congressional_districts dm," +
      tablePrefix +
      "countries cn WHERE dm.id !='' AND dm.country_code=cn.iso2 and cn.iso3  IN('USA') and concat(concat(state_code, '-'), cd116_fip) " +
      DATASOURCE_CONFIG.QUERY_LIKE +
      " '%" +
      query +
      "%' " +
      congWhere +
      " GROUP BY dm.id,dm.state_code, cd116_fip,cn.iso3 ORDER BY name limit 50;";
    if (DATASOURCE_CONFIG.DATASOURCE == "mysql") {
      CongQry =
        "SELECT dm.id AS id,CONCAT(dm.state_name, ' Congressional District ', dm.id) AS name,cn.iso3 as country_code_iso3,dm.latitude as lat,dm.longitude as lng FROM " +
        tablePrefix +
        "congressional_districts dm," +
        tablePrefix +
        "countries cn WHERE dm.id !='' AND dm.country_code=cn.iso2 and cn.iso3  IN('USA') and CONCAT(dm.state_name, ' Congressional District ', dm.id) " +
        DATASOURCE_CONFIG.QUERY_LIKE +
        " '%" +
        query +
        "%' " +
        congWhere +
        " order by name  limit 50;";
    }
    const queryBody = {
      queries: [
        {
          query: CongQry,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetAllSenateDistrictsListThunk = createAsyncThunk(
  "audienceManagement/GetAllSenateDistrictsListThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    var country = payload.cc;
    let congWhere = "";
    let selCongs = [];
    var selectedValuesArr = payload?.selValue ? payload?.selValue : [];
    for (let x = 0; x < selectedValuesArr.length; x++) {
      let info = selectedValuesArr[x];
      if (info?.id) {
        selCongs.push(info.id);
      }
    }

    congWhere =
      selCongs.length > 0
        ? " and dm.geo_id NOT IN('" + selCongs.join("','") + "')"
        : "";

    var Query = "";

    if (DATASOURCE_CONFIG.DATASOURCE == "mysql") {
      // if(payload.q.length>0){
      //     var aaa="'"+payload.q.join("','")+"'";
      // }
      Query =
        "SELECT dm.geo_id AS id,CONCAT(dm.state_code, '-',dm.name) AS name ,dm.latitude as lat,dm.longitude as lng FROM " +
        tablePrefix +
        "state_legislative_districts dm WHERE dm.geo_id != '' and sld='U' and CONCAT(dm.state_code, '-',dm.name) " +
        DATASOURCE_CONFIG.QUERY_LIKE +
        " '%" +
        payload.q +
        "%' " +
        congWhere +
        " ORDER BY name limit 50;";
    } else {
      Query =
        "SELECT dm.geo_id AS id,concat(concat(state_code, '('), concat(district,')')) AS name ,dm.latitude as lat,dm.longitude as lng FROM " +
        tablePrefix +
        "state_legislative_districts dm WHERE dm.geo_id != '' and sld='U' and concat(concat(state_code, '('), concat(district,')')) " +
        DATASOURCE_CONFIG.QUERY_LIKE +
        " '%" +
        payload.q +
        "%' " +
        congWhere +
        " GROUP BY dm.geo_id,dm.state_code,district ORDER BY name limit 50;";
    }

    const queryBody = {
      queries: [
        {
          query: Query,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetAllHouseDistrictsListThunk = createAsyncThunk(
  "audienceManagement/GetAllHouseDistrictsListThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    var country = payload.cc;
    let congWhere = "";
    let selCongs = [];
    var selectedValuesArr = payload?.selValue ? payload?.selValue : [];
    for (let x = 0; x < selectedValuesArr.length; x++) {
      let info = selectedValuesArr[x];
      if (info?.id) {
        selCongs.push(info.id);
      }
    }

    congWhere =
      selCongs.length > 0
        ? " and dm.geo_id NOT IN('" + selCongs.join("','") + "')"
        : "";

    var Query = "";

    if (DATASOURCE_CONFIG.DATASOURCE == "mysql") {
      // if(payload.q.length>0){
      //     var aaa="'"+payload.q.join("','")+"'";
      // }
      Query =
        "SELECT dm.geo_id AS id,CONCAT(dm.state_code, '-',dm.name) AS name ,dm.latitude as lat,dm.longitude as lng FROM " +
        tablePrefix +
        "state_legislative_districts dm WHERE dm.geo_id != '' and sld='L' and CONCAT(dm.state_code, '-',dm.name) " +
        DATASOURCE_CONFIG.QUERY_LIKE +
        " '%" +
        payload.q +
        "%' " +
        congWhere +
        " ORDER BY name limit 5;";
    } else {
      Query =
        "SELECT dm.geo_id AS id,concat(concat(state_code, '('), concat(district,')')) AS name ,dm.latitude as lat,dm.longitude as lng FROM " +
        tablePrefix +
        "state_legislative_districts dm WHERE dm.geo_id != '' and sld='L' and concat(concat(state_code, '('), concat(district,')')) " +
        DATASOURCE_CONFIG.QUERY_LIKE +
        " '%" +
        payload.q +
        "%' " +
        congWhere +
        " GROUP BY dm.geo_id,dm.state_code,district ORDER BY name limit 5;";
    }

    const queryBody = {
      queries: [
        {
          query: Query,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetCategoriesListThunk = createAsyncThunk(
  "audienceManagement/GetCategoriesListThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    var country = payload.cc;
    var query = payload.q;
    const queryBody = {
      // queries: [
      //   {
      //     query:
      //       "select name AS id,name, display_name from consent.iab_data WHERE display_name "+DATASOURCE_CONFIG.QUERY_LIKE+" '%" +
      //       query +
      //       "%' ORDER BY name limit 100;",
      //     datasource: "redshift",
      //   },
      // ],
      queries: [
        {
          query:
            "select name AS id,name, display_name from " +
            tablePrefix +
            "iab_data",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      // console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetPublishersListThunk = createAsyncThunk(
  "audienceManagement/GetPublishersListThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    var country = payload.cc;
    var query = payload.q;
    var isSysAdmin = payload.user_data.is_sys_admin;

    let selWhere = "";
    let selectedIds = [];
    var selectedValuesArr = payload?.selValue ? payload?.selValue : [];
    for (let x = 0; x < selectedValuesArr.length; x++) {
      let info = selectedValuesArr[x];
      if (info?.id) {
        selectedIds.push(info.id);
      }
    }

    selWhere =
      selectedIds.length > 0
        ? " and p.id NOT IN('" + selectedIds.join("','") + "')"
        : "";
    let pubNameLike =
      query != ""
        ? " and p.name " + DATASOURCE_CONFIG.QUERY_LIKE + " '%" + query + "%'"
        : "";
    let accNameLike =
      query != ""
        ? " and a.name " + DATASOURCE_CONFIG.QUERY_LIKE + " '%" + query + "%'"
        : "";
    let pubquery =
      "select p.id,p.pub_code, p.name from " +
      tablePrefix +
      "publishers as p where p.active='1' and p.qps>1" +
      selWhere +
      pubNameLike;

    let accountsQuery =
      "select a.id,CONCAT('account_',a.id) AS pub_code,CONCAT(a.company,' - ',a.name) AS name from " +
      tablePrefix +
      "accounts as a," +
      tablePrefix +
      "publishers p " +
      " where a.id=p.accountid and p.qps>1 " +
      selWhere +
      accNameLike;
    let finalPubQuery = "";
    if (payload?.page == "audience") {
      finalPubQuery = accountsQuery;
    } else {
      finalPubQuery =
        "SELECT id,pub_code,name FROM ((" +
        pubquery +
        ") union (" +
        accountsQuery +
        ")) A";
    }

    if (isSysAdmin != 1) {
      if (payload.user_data.user_assoc_publishers.length > 0) {
        let pubs =
          "'" + payload.user_data.user_assoc_publishers.join("','") + "'";
        pubquery =
          "select p.id,p.pub_code, p.name from " +
          tablePrefix +
          "publishers as p where p.id IN (" +
          pubs +
          ") and p.active='1' and p.qps>1" +
          selWhere +
          pubNameLike;

        accountsQuery =
          "select a.id,CONCAT('account_',a.id) AS pub_code,CONCAT(a.company,' - ',a.name) AS name from " +
          tablePrefix +
          "accounts as a," +
          tablePrefix +
          "publishers p " +
          " where a.id=p.accountid and p.id IN( " +
          pubs +
          ") and p.qps>1" +
          selWhere +
          accNameLike;

        if (payload?.page == "audience") {
          finalPubQuery = accountsQuery;
        } else {
          finalPubQuery =
            "SELECT id,pub_code,name FROM ((" +
            pubquery +
            ") union (" +
            accountsQuery +
            ")) A";
        }
      } else {
        let userAccountsArr = [];
        if (payload.user_data.user_assoc_accounts?.advertiser?.length > 0) {
          userAccountsArr = payload.user_data.user_assoc_accounts?.advertiser;
        }
        if (payload.user_data.user_assoc_accounts?.publisher?.length > 0) {
          userAccountsArr = userAccountsArr.concat(
            payload.user_data.user_assoc_accounts?.publisher
          );

          //userAccountsArr = payload.user_data.user_assoc_accounts?.publisher;
        }
        //var uniqueAccounts = a.filter(onlyUnique);
        let useraccounts = "'" + userAccountsArr.join("','") + "'";
        pubquery =
          "select p.id,p.pub_code, p.name from " +
          tablePrefix +
          "publishers as p where p.accountid IN (" +
          useraccounts +
          ") and p.active='1' and p.qps>1 " +
          selWhere +
          pubNameLike;

        accountsQuery =
          "select a.id,CONCAT('account_',a.id) AS pub_code,CONCAT(a.company,' - ',a.name) AS name from " +
          tablePrefix +
          "accounts as a," +
          tablePrefix +
          "publishers p " +
          " where a.id=p.accountid and p.accountid IN( " +
          useraccounts +
          ") and p.qps>1 " +
          selWhere +
          accNameLike;
        if (payload?.page == "audience") {
          finalPubQuery = accountsQuery;
        } else {
          finalPubQuery =
            "SELECT id,pub_code,name FROM ((" +
            pubquery +
            ") union (" +
            accountsQuery +
            ")) A";
        }
      }
      console.log("Pub Query1:", pubquery);
    }

    console.log("Pub Query:", finalPubQuery);

    const queryBody = {
      queries: [
        {
          query: finalPubQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetPlacementIdsListThunk = createAsyncThunk(
  "audienceManagement/GetPlacementIdsListThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    var country = payload.cc;
    var query = payload.q;
    var pubCodes = payload?.pub_code ? payload.pub_code : [];
    var pubwhere = "";
    if (pubCodes.length > 0) {
      pubwhere = " pp.pub_code in ('" + pubCodes.join("','") + "') and ";
    }

    let selWhere = "";
    let selectedIds = [];
    var selectedValuesArr = payload?.selValue ? payload?.selValue : [];
    for (let x = 0; x < selectedValuesArr.length; x++) {
      let info = selectedValuesArr[x];
      if (info?.id) {
        selectedIds.push(info.id);
      }
    }

    selWhere =
      selectedIds.length > 0
        ? " and pp.id NOT IN('" + selectedIds.join("','") + "')"
        : "";

    var isSysAdmin = payload.user_data.is_sys_admin;

    let placeQuery =
      "select pp.id,pp.name,pp.pub_code from " +
      tablePrefix +
      "publisher_placements as pp where " +
      pubwhere +
      " name " +
      DATASOURCE_CONFIG.QUERY_LIKE +
      " '%" +
      query +
      "%' " +
      selWhere +
      " limit 5;";

    if (isSysAdmin != 1) {
      if (payload.user_data?.user_assoc_publishers?.length > 0) {
        let pubaccounts =
          "'" + payload.user_data.user_assoc_publishers.join("','") + "'";
        placeQuery =
          "select pp.id,pp.name,pp.pub_code from " +
          tablePrefix +
          "publisher_placements pp," +
          tablePrefix +
          "publishers p where " +
          pubwhere +
          " pp.name " +
          DATASOURCE_CONFIG.QUERY_LIKE +
          " '%" +
          query +
          "%' and pp.pub_code=p.pub_code and  p.id IN (" +
          pubaccounts +
          ") and p.active='1' " +
          selWhere +
          " limit 5;";
      } else {
        let userAccountsArr = [];
        if (payload.user_data.user_assoc_accounts?.advertiser?.length > 0) {
          userAccountsArr = payload.user_data.user_assoc_accounts?.advertiser;
        }
        if (payload.user_data.user_assoc_accounts?.publisher?.length > 0) {
          userAccountsArr = userAccountsArr.concat(
            payload.user_data.user_assoc_accounts?.publisher
          );
        }
        let useraccounts = "'" + userAccountsArr.join("','") + "'";
        placeQuery =
          "select pp.id,pp.name,pp.pub_code from " +
          tablePrefix +
          "publisher_placements pp," +
          tablePrefix +
          "publishers p where " +
          pubwhere +
          " pp.name " +
          DATASOURCE_CONFIG.QUERY_LIKE +
          " '%" +
          query +
          "%' and pp.pub_code=p.pub_code and p.accountid IN (" +
          useraccounts +
          ") and p.active='1' " +
          selWhere +
          " limit 5;";
      }
    }

    const queryBody = {
      queries: [
        {
          query: placeQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    console.log("Place Query:", queryBody);
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetSupplyDealIdsListThunk = createAsyncThunk(
  "audienceManagement/GetSupplyDealIdsListThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    var query = payload.q;
    var isSysAdmin = payload.user_data.is_sys_admin;

    let selWhere = "";
    let selectedIds = [];
    var selectedValuesArr = payload?.selValue ? payload?.selValue : [];
    for (let x = 0; x < selectedValuesArr.length; x++) {
      let info = selectedValuesArr[x];
      if (info?.id) {
        selectedIds.push(info.id);
      }
    }

    selWhere =
      selectedIds.length > 0
        ? " and dealid NOT IN('" + selectedIds.join("','") + "')"
        : "";

    let placeQuery =
      "select dealid as id,name from " +
      tablePrefix +
      "rtb_deals_supply where name " +
      DATASOURCE_CONFIG.QUERY_LIKE +
      " '%" +
      query +
      "%' and status!=2 " +
      selWhere +
      "  limit 5;";

    if (isSysAdmin != 1) {
      if (payload.user_data?.user_assoc_publishers?.length > 0) {
        let pubaccounts =
          "'" + payload.user_data.user_assoc_publishers.join("','") + "'";
        placeQuery =
          "select dealid as id,name from " +
          tablePrefix +
          "rtb_deals_supply where name " +
          DATASOURCE_CONFIG.QUERY_LIKE +
          " '%" +
          query +
          "%' and accountid IN(" +
          pubaccounts +
          ") and status!=2 " +
          selWhere +
          " UNION select " +
          tablePrefix +
          "rtb_deals_supply.dealid as id, " +
          tablePrefix +
          "rtb_deals_supply.name as name from " +
          tablePrefix +
          "rtb_deals_supply_account_assoc, " +
          tablePrefix +
          "rtb_deals_supply where " +
          tablePrefix +
          "rtb_deals_supply_account_assoc.dealid= " +
          tablePrefix +
          "rtb_deals_supply.dealid and " +
          tablePrefix +
          "rtb_deals_supply_account_assoc.accountid IN(" +
          pubaccounts +
          ") limit 5;";
      } else {
        let userAccountsArr = [];
        if (payload.user_data.user_assoc_accounts?.advertiser?.length > 0) {
          userAccountsArr = payload.user_data.user_assoc_accounts?.advertiser;
        }
        if (payload.user_data.user_assoc_accounts?.publisher?.length > 0) {
          userAccountsArr = userAccountsArr.concat(
            payload.user_data.user_assoc_accounts?.publisher
          );
        }
        let useraccounts = "'" + userAccountsArr.join("','") + "'";
        placeQuery =
          "select dealid as id,name from " +
          tablePrefix +
          "rtb_deals_supply where name " +
          DATASOURCE_CONFIG.QUERY_LIKE +
          " '%" +
          query +
          "%' and accountid IN(" +
          useraccounts +
          ") and status!=2 " +
          selWhere +
          " UNION select " +
          tablePrefix +
          "rtb_deals_supply.dealid as id, " +
          tablePrefix +
          "rtb_deals_supply.name as name from " +
          tablePrefix +
          "rtb_deals_supply_account_assoc, " +
          tablePrefix +
          "rtb_deals_supply where " +
          tablePrefix +
          "rtb_deals_supply_account_assoc.dealid= " +
          tablePrefix +
          "rtb_deals_supply.dealid and " +
          tablePrefix +
          "rtb_deals_supply_account_assoc.accountid IN(" +
          useraccounts +
          ") limit 5;";
      }
    }

    const queryBody = {
      queries: [
        {
          query: placeQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };

    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetBundleIdsListThunk = createAsyncThunk(
  "audienceManagement/GetBundleIdsListThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    var query = payload.q;
    var isSysAdmin = payload.user_data.is_sys_admin;
    var payLoadAccounts = payload.accountIds;
    var page = payload.page;

    let selWhere = "";
    let selectedIds = [];
    var selectedValuesArr = payload?.selValue ? payload?.selValue : [];
    for (let x = 0; x < selectedValuesArr.length; x++) {
      let info = selectedValuesArr[x];
      if (info?.id) {
        selectedIds.push(info.id);
      }
    }

    selWhere =
      selectedIds.length > 0
        ? " and BundleId NOT IN('" + selectedIds.join("','") + "')"
        : "";

    let bundleIdQuery =
      "(select BundleId as id,CONCAT(BundleId,' [',OwnName,']') as name,0 as is_group from " +
      tablePrefix +
      "applications where status=100 and BundleId !='' and CONCAT(BundleId,' [',OwnName,']') " +
      DATASOURCE_CONFIG.QUERY_LIKE +
      " '%" +
      query +
      "%' " +
      selWhere +
      " group by BundleId order by BundleId)";

    let bidderaccounts = "";
    if (isSysAdmin != 1) {
      if (
        page == "bidder" &&
        payload.user_data?.user_assoc_bidders?.length > 0
      ) {
        bidderaccounts =
          "'" + payload.user_data.user_assoc_bidders.join("','") + "'";
      } else if (payLoadAccounts.length > 0) {
        bidderaccounts = "'" + payLoadAccounts.join("','") + "'";
      }
    } else {
      if (payLoadAccounts.length > 0) {
        bidderaccounts = "'" + payLoadAccounts.join("','") + "'";
      }
    }

    let bundleGroupQuery = "";
    let selGroupIdWhere =
      selectedIds.length > 0
        ? " and id NOT IN('" + selectedIds.join("','") + "')"
        : "";
    if (isSysAdmin != 1) {
      bundleGroupQuery =
        "(select tg_groups .id as id, CONCAT(tg_groups .name,' [',tg_groups .id,'] ') as name,1 as is_group from " +
        tablePrefix +
        "targeting_groups as tg_groups ," +
        tablePrefix +
        "targetgroups_account_assoc as assoc where  tg_groups .id=assoc.groupid and tg_groups.type='bundleid'  and assoc.accountid IN(" +
        bidderaccounts +
        ") and CONCAT(tg_groups .name,' [',tg_groups .id,']') " +
        DATASOURCE_CONFIG.QUERY_LIKE +
        " '%" +
        query +
        "%' " +
        selGroupIdWhere +
        "  order by name)";
    } else {
      bundleGroupQuery =
        "(select tg_groups.id as id, CONCAT(tg_groups.name,' [',tg_groups.id,'] ') as name,1 as is_group from " +
        tablePrefix +
        "targeting_groups as tg_groups where tg_groups.type='bundleid'  and CONCAT(tg_groups.name,' [',tg_groups.id,']') " +
        DATASOURCE_CONFIG.QUERY_LIKE +
        " '%" +
        query +
        "%' " +
        selGroupIdWhere +
        " order by name)";
    }

    let unionQuery =
      "Select id,name,is_group from (" +
      bundleIdQuery +
      " UNION " +
      bundleGroupQuery +
      " limit 5) A";

    // if (isSysAdmin != 1) {
    //   if (payload.user_data?.user_assoc_publishers?.length > 0) {
    //     let pubaccounts =
    //       "'" + payload.user_data.user_assoc_publishers.join("','") + "'";
    //     placeQuery =
    //       "select dealid as id,name from " +
    //       tablePrefix +
    //       "rtb_deals_supply where name " +
    //       DATASOURCE_CONFIG.QUERY_LIKE +
    //       " '%" +
    //       query +
    //       "%' and accountid=" +
    //       pubaccounts +
    //       " and status!=2 " +
    //       selWhere +
    //       " limit 5;";
    //   } else {
    //     let userAccountsArr = [];
    //     if (payload.user_data.user_assoc_accounts?.advertiser?.length > 0) {
    //       userAccountsArr = payload.user_data.user_assoc_accounts?.advertiser;
    //     }
    //     if (payload.user_data.user_assoc_accounts?.publisher?.length > 0) {
    //       userAccountsArr = userAccountsArr.concat(
    //         payload.user_data.user_assoc_accounts?.publisher
    //       );
    //     }
    //     let useraccounts = "'" + userAccountsArr.join("','") + "'";
    //     placeQuery =
    //       "select dealid as id,name from " +
    //       tablePrefix +
    //       "rtb_deals_supply where name " +
    //       DATASOURCE_CONFIG.QUERY_LIKE +
    //       " '%" +
    //       query +
    //       "%' and accountid=" +
    //       useraccounts +
    //       " and status!=2 " +
    //       selWhere +
    //       " limit 5;";
    //   }
    // }

    const queryBody = {
      queries: [
        {
          query: unionQuery, //bundleIdQuery + " UNION " + bundleGroupQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };

    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetStatesListByCountryCodeThunk = createAsyncThunk(
  "audienceManagement/GetStatesListByCountryCodeThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    const queryBody = {
      queries: [
        {
          query:
            "select name,iso2 as id from " +
            tablePrefix +
            "states where country_code='" +
            payload.country_code +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetAudienceSegmentsListThunk = createAsyncThunk(
  "audienceManagement/GetAudienceSegmentsListThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    var isSysAdmin = payload?.authUserData?.is_sys_admin;
    var userProfile = payload?.authUserData?.user_assoc_profiles;
    var segmentFilters = payload?.segmentFilters;
    let condition = [];

    console.log("segmentFilters:", segmentFilters);
    if (
      payload?.search != "" &&
      payload?.search != undefined &&
      payload?.search != null
    ) {
      condition.push(
        "asp.segment_name " +
          DATASOURCE_CONFIG.QUERY_LIKE +
          " '%" +
          addslashes(payload.search) +
          "%'"
      );
    }
    if (segmentFilters?.accounts?.length > 0) {
      condition.push(
        "asp.whitelist_accountid IN ('" +
          segmentFilters?.accounts.join("','") +
          "')"
      );

      if (isSysAdmin != 1) {
        condition.push(
          "asp.provider IN ('" + payload?.providers?.join("','") + "')"
        );
      }
    } else if (isSysAdmin != 1) {
      let userPubAccounts =
        payload?.authUserData?.user_assoc_accounts?.publisher != undefined &&
        payload?.authUserData?.user_assoc_accounts?.publisher.length > 0
          ? payload?.authUserData?.user_assoc_accounts?.publisher
          : [];

      let userAdvAccounts =
        payload?.authUserData?.user_assoc_accounts?.advertiser != undefined &&
        payload.authUserData?.user_assoc_accounts?.advertiser.length > 0
          ? payload.authUserData?.user_assoc_accounts?.advertiser
          : [];
      let userAllAccounts = [...userPubAccounts, ...userAdvAccounts];

      if (userAllAccounts.length > 0) {
        condition.push(
          "asp.whitelist_accountid IN ('" + userAllAccounts.join("','") + "')"
        );
      } else {
        condition.push("asp.whitelist_accountid  IN ('0')");
      }
      // if (
      //   userProfile.includes("publisher") &&
      //   payload.authUserData?.user_assoc_accounts?.publisher.length > 0
      // ) {
      //   condition.push(
      //     "asp.whitelist_accountid IN ('" +
      //       payload.authUserData?.user_assoc_accounts?.publisher.join("','") +
      //       "')"
      //   );
      // } else {
      //   condition.push("asp.whitelist_accountid  IN ('0')");
      // }

      condition.push(
        "asp.provider IN ('" + payload?.providers?.join("','") + "')"
      );
    }

    if (segmentFilters?.segmenttypes?.length > 0) {
      condition.push(
        " asp.portal in ('" + segmentFilters?.segmenttypes.join("','") + "') "
      );
    } else {
      condition.push(" asp.portal in ('advertiser','publisher') ");
    }

    let where = "";
    condition.push(
      "asp.is_active='1' and asp.expiry_date >= CURDATE()" // now()
    );
    if (condition.length > 0) {
      where = "where " + condition.join(" and ") + "";
    }

    console.log("where:", where);

    const queryBody = {
      queries: [
        {
          query:
            "select asp.id,asp.segment_name,asp.segment,asp.provider,asp.price,asp.displayname,asp.created_at,asp.portal,asp.whitelist_accountid,a.company as account_name,asp.expiry_date,SUM(ascn.uniques) AS uniques from " +
            tablePrefix +
            " audience_segments_providers as asp JOIN " +
            tablePrefix +
            " accounts as a ON a.id = asp.whitelist_accountid LEFT JOIN audience_segments_providers_counts AS `ascn` ON asp.segment = ascn.segment " +
            where +
            " GROUP BY asp.segment  order by asp.created_at desc ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);

      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const updateAudienceSegmentStatusThunk = createAsyncThunk(
  "audienceManagement/updateAudienceSegmentStatusThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    const queryBody = {
      queries: [
        {
          query:
            "update " +
            tablePrefix +
            "audience_segments_providers set is_active ='" +
            payload.status +
            "',updated_at=" +
            DATASOURCE_CONFIG.CURRENT_DATE +
            " where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetAudienceSegmentDetailsThunk = createAsyncThunk(
  "audienceManagement/GetAudienceSegmentDetailsThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    const queryBody = {
      queries: [
        {
          query:
            "select segment_name as name,target_country,custom_no_days,custom_start_date,custom_end_date,is_enabled,whitelist_accountid as accountid,provider,portal,segment,expiry_date,segment_sub_type,segment_data,min_days,min_visits,look_alike,target_app_language,target_app,target_cats,target_pubs,target_bundles,target_device_os,target_devicetype,target_gender,target_age,target_days,target_hours from " +
            tablePrefix +
            "audience_segments_providers where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "select * from " +
            tablePrefix +
            "crm_sources_audience_assoc where audience_id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        `${getDataEndPoint}`,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const CreateUpdateAudienceSegmentDetailsThunk = createAsyncThunk(
  "audienceManagement/CreateUpdateAudienceSegmentDetailsThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    let Query = "";
    let crmQuery = [];
    if (payload.id == "" || payload.id == null || payload.id == undefined) {
      let crmsAssocInfo = AudienceCrmsAssocData(
        payload.crms,
        payload.audience_create_id
      );
      payload.crms = crmsAssocInfo["info"];
      crmQuery = crmsAssocInfo["query"];

      if (payload.customDays != "") {
        Query =
          "insert into " +
          tablePrefix +
          "audience_segments_providers (id,segment_name,target_country,custom_no_days,is_enabled,whitelist_accountid,provider,displayname,portal,segment,created_by,expiry_date,created_at,updated_at,segment_sub_type,segment_type,segment_data,min_days,min_visits,look_alike,target_app_language,target_app,target_cats,target_pubs,target_bundles,target_device_os,target_devicetype,target_gender,target_age,target_days,target_hours) values('" +
          payload.audience_create_id +
          "','" +
          addslashes(payload.name) +
          "','" +
          payload.country +
          "','" +
          payload.customDays +
          "','" +
          payload.isEnable +
          "','" +
          payload.account +
          "','" +
          payload.provider +
          "','" +
          payload.display_name +
          "','" +
          payload.portal +
          "','" +
          payload.segment +
          "','" +
          payload.created_by +
          "','" +
          payload.expiry_date +
          "'," +
          DATASOURCE_CONFIG.CURRENT_DATE +
          "," +
          DATASOURCE_CONFIG.CURRENT_DATE +
          ",'" +
          payload.segment_sub_type +
          "','" +
          payload.segment_type +
          "','" +
          payload.segment_data +
          "','" +
          payload.min_days +
          "','" +
          payload.min_visits +
          "','" +
          payload.lookAlike +
          "','" +
          payload.target_app_language +
          "','" +
          payload.target_app +
          "','" +
          payload.target_cats +
          "','" +
          payload.target_pubs +
          "','" +
          payload.target_bundles +
          "','" +
          payload.target_device_os +
          "','" +
          payload.target_devicetype +
          "','" +
          payload.target_gender +
          "','" +
          payload.target_age +
          "','" +
          payload.target_days +
          "','" +
          payload.target_hours +
          "') ";
      } else {
        Query =
          "insert into " +
          tablePrefix +
          "audience_segments_providers (id,segment_name,target_country,custom_no_days,custom_start_date,custom_end_date,is_enabled,whitelist_accountid,provider,displayname,portal,segment,created_by,expiry_date,created_at,updated_at,segment_sub_type,segment_type,segment_data,min_days,min_visits,look_alike,target_app_language,target_app,target_cats,target_pubs,target_bundles,target_device_os,target_devicetype,target_gender,target_age,target_days,target_hours) values('" +
          payload.audience_create_id +
          "','" +
          addslashes(payload.name) +
          "','" +
          payload.country +
          "','" +
          payload.customDays +
          "','" +
          payload.customStartDate +
          "','" +
          payload.customEndDate +
          "','" +
          payload.isEnable +
          "','" +
          payload.account +
          "','" +
          payload.provider +
          "','" +
          payload.display_name +
          "','" +
          payload.portal +
          "','" +
          payload.segment +
          "','" +
          payload.created_by +
          "','" +
          payload.expiry_date +
          "'," +
          DATASOURCE_CONFIG.CURRENT_DATE +
          "," +
          DATASOURCE_CONFIG.CURRENT_DATE +
          ",'" +
          payload.segment_sub_type +
          "','" +
          payload.segment_type +
          "','" +
          payload.segment_data +
          "','" +
          payload.min_days +
          "','" +
          payload.min_visits +
          "','" +
          payload.lookAlike +
          "','" +
          payload.target_app_language +
          "','" +
          payload.target_app +
          "','" +
          payload.target_cats +
          "','" +
          payload.target_pubs +
          "','" +
          payload.target_bundles +
          "','" +
          payload.target_device_os +
          "','" +
          payload.target_devicetype +
          "','" +
          payload.target_gender +
          "','" +
          payload.target_age +
          "','" +
          payload.target_days +
          "','" +
          payload.target_hours +
          "') ";
      }
    } else {
      let crmsAssocInfo = AudienceCrmsAssocData(payload.crms, payload.id);
      payload.crms = crmsAssocInfo["info"];
      crmQuery = crmsAssocInfo["query"];
      var inventoryTabFields = "";
      if (payload?.update_inventory_tab) {
        inventoryTabFields =
          ",target_pubs='" +
          payload.target_pubs +
          "',target_bundles='" +
          payload.target_bundles +
          "',target_app_language='" +
          payload.target_app_language +
          "',target_app='" +
          payload.target_app +
          "',target_cats='" +
          payload.target_cats +
          "'";
      }
      if (payload.customDays != "") {
        Query =
          "update " +
          tablePrefix +
          "audience_segments_providers set segment_name='" +
          addslashes(payload.name) +
          "',target_country='" +
          payload.country +
          "',custom_no_days='" +
          payload.customDays +
          "',custom_start_date=NULL,custom_end_date=NULL" +
          ",is_enabled='" +
          payload.isEnable +
          "',provider='" +
          payload.provider +
          "',whitelist_accountid='" +
          payload.account +
          "',displayname='" +
          payload.display_name +
          "',expiry_date='" +
          payload.expiry_date +
          "',updated_at=" +
          DATASOURCE_CONFIG.CURRENT_DATE +
          ",segment_sub_type='" +
          payload.segment_sub_type +
          "',segment_type='" +
          payload.segment_type +
          "',segment_data='" +
          payload.segment_data +
          "',min_days='" +
          payload.min_days +
          "',min_visits='" +
          payload.min_visits +
          "',look_alike='" +
          payload.lookAlike +
          "',target_device_os='" +
          payload.target_device_os +
          "',target_devicetype='" +
          payload.target_devicetype +
          "',target_gender='" +
          payload.target_gender +
          "',target_age='" +
          payload.target_age +
          "',target_days='" +
          payload.target_days +
          "',target_hours='" +
          payload.target_hours +
          "' " +
          inventoryTabFields +
          " where id='" +
          payload.id +
          "'";
      } else {
        Query =
          "update " +
          tablePrefix +
          "audience_segments_providers set segment_name='" +
          addslashes(payload.name) +
          "',target_country='" +
          payload.country +
          "',custom_no_days='" +
          payload.customDays +
          "',custom_start_date='" +
          payload.customStartDate +
          "',custom_end_date='" +
          payload.customEndDate +
          "',is_enabled='" +
          payload.isEnable +
          "',provider='" +
          payload.provider +
          "',whitelist_accountid='" +
          payload.account +
          "',displayname='" +
          payload.display_name +
          "',expiry_date='" +
          payload.expiry_date +
          "',updated_at=" +
          DATASOURCE_CONFIG.CURRENT_DATE +
          ",segment_sub_type='" +
          payload.segment_sub_type +
          "',segment_type='" +
          payload.segment_type +
          "',segment_data='" +
          payload.segment_data +
          "',min_days='" +
          payload.min_days +
          "',min_visits='" +
          payload.min_visits +
          "',look_alike='" +
          payload.lookAlike +
          "',target_device_os='" +
          payload.target_device_os +
          "',target_devicetype='" +
          payload.target_devicetype +
          "',target_gender='" +
          payload.target_gender +
          "',target_age='" +
          payload.target_age +
          "',target_days='" +
          payload.target_days +
          "',target_hours='" +
          payload.target_hours +
          "' " +
          inventoryTabFields +
          " where id='" +
          payload.id +
          "'";
      }
    }

    let audienceQuery = [
      {
        query: Query,
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      },
    ];
    let queriesArr = [...audienceQuery, ...crmQuery];

    const queryBody = {
      queries: queriesArr,
    };
    console.log(" Audience Queries:", queryBody);
    try {
      const response = await axiosApiInstance.post(
        `${updateDataEndPoint}`,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const CreateUpdateAudienceLocationDetailsThunk = createAsyncThunk(
  "audienceManagement/CreateUpdateAudienceLocationDetailsThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    let queriesArr = [];
    var audienceId = payload.audience_id;
    var action = payload.action;
    console.log("payload", payload);
    if (payload.is_location) {
      let InsertQuery =
        "insert into " +
        tablePrefix +
        "audience_location_groups (id,name,audience_id,target_city,target_state,target_dma,target_counties,target_postalcode,target_brands,target_congressional_districts,target_senate_districts,target_house_districts,latlon_radius,addresses_radius,poi_radius,min_visits,min_days,geo_points,target_addresses,geo_polygons,target_poi,target_latlon_groups,target_polygon_groups,target_address_groups,created_by,creation_date,updated_date,target_email_groups,target_ipaddress_groups) values";
      let InsertValuesArr = [];

      // let InsertLocationLatLongQry =
      //   "Insert into " +
      //   tablePrefix +
      //   "audience_location_groups_latlon (id,location_group_id,audience_id,target_latlon_groups,type,creation_date) values ";

      // let InsertLocationAddressesQry =
      //   "Insert into " +
      //   tablePrefix +
      //   "audience_location_groups_addresses (location_group_id,audience_id,addresses,type,creation_date) values ";
      // let InsertLocationPolygongQry =
      //   "Insert into " +
      //   tablePrefix +
      //   "audience_location_groups_polygons (id,location_group_id,audience_id,target_polygon_groups,type,creation_date) values";
      // let InsertLocationPoiQry =
      //   "Insert into " +
      //   tablePrefix +
      //   "audience_location_groups_poi (location_group_id,audience_id,target_poi,creation_date) values";

      // let InsertLocationLatLongValues = [];
      // let InsertLocationAddressesValues = [];
      // let InsertLocationPolygongValues = [];
      // let InsertLocationPoiValues = [];

      var locationGroupFieldsInfo = payload.formInfo;

      if (action == "edit") {
        queriesArr.push({
          query:
            "update " +
            tablePrefix +
            "audience_location_groups set is_active=0,updated_date=" +
            DATASOURCE_CONFIG.CURRENT_DATE +
            " where  audience_id='" +
            audienceId +
            "' ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
        /*** Delete all campaign location groups child tables ***/
        // queriesArr.push({
        //   query:
        //     "delete from consent.audience_location_groups_latlon where audience_id='" +
        //     audienceId +
        //     "' ",
        //   datasource: "redshift",
        // });
        // queriesArr.push({
        //   query:
        //     "delete from consent.audience_location_groups_polygons where audience_id='" +
        //     audienceId +
        //     "' ",
        //   datasource: "redshift",
        // });

        // queriesArr.push({
        //   query:
        //     "delete from " +
        //     tablePrefix +
        //     "audience_location_groups_addresses where audience_id='" +
        //     audienceId +
        //     "' ",
        //   datasource: DATASOURCE_CONFIG.DATASOURCE,
        // });

        // queriesArr.push({
        //   query:
        //     "delete from " +
        //     tablePrefix +
        //     "audience_location_groups_poi where audience_id='" +
        //     audienceId +
        //     "' ",
        //   datasource: DATASOURCE_CONFIG.DATASOURCE,
        // });
      }
      console.log("locationGroupFieldsInfo", locationGroupFieldsInfo);
      for (var n = 0; n < locationGroupFieldsInfo.length; n++) {
        var locationInfo = locationGroupFieldsInfo[n];
        var locId = "";
        if (
          locationInfo.id == "" ||
          locationInfo.id == null ||
          locationInfo.id == undefined
        ) {
          // Create case
          //var insertId = uuid();
          locId = locationInfo.insert_id;
          InsertValuesArr.push(
            "('" +
              locId +
              "','" +
              addslashes(locationInfo.name) +
              "','" +
              audienceId +
              "','" +
              locationInfo.target_city +
              "','" +
              locationInfo.target_state +
              "','" +
              locationInfo.target_dma +
              "','" +
              locationInfo.target_counties +
              "','" +
              locationInfo.target_zipcode +
              "','" +
              locationInfo.target_brands +
              "','" +
              locationInfo.target_congressional_districts +
              "','" +
              locationInfo.target_senate_districts +
              "','" +
              locationInfo.target_house_districts +
              "','" +
              locationInfo.latlon_radius +
              "','" +
              locationInfo.addresses_radius +
              "','" +
              locationInfo.poi_radius +
              "','" +
              locationInfo.min_visits +
              "','" +
              locationInfo.min_days +
              "','" +
              addslashes(locationInfo.target_latlon) +
              "','" +
              addslashes(locationInfo.target_addresses) +
              "','" +
              addslashes(locationInfo.target_polygon) +
              "','" +
              addslashes(locationInfo.target_poi) +
              "','" +
              locationInfo.target_latlon_group +
              "','" +
              locationInfo.target_polygon_group +
              "','" +
              locationInfo.target_address_group +
              "','" +
              payload.created_by +
              "'," +
              DATASOURCE_CONFIG.CURRENT_DATE +
              "," +
              DATASOURCE_CONFIG.CURRENT_DATE +
              ",'" +
              addslashes(locationInfo.target_email) +
              "','" +
              (locationInfo.target_ipaddress_groups || "") +
              "')"
          );
        } else {
          // Update case
          locId = locationInfo.id;
          queriesArr.push({
            query:
              " update " +
              tablePrefix +
              "audience_location_groups set is_active=1,target_city='" +
              locationInfo.target_city +
              "',target_state='" +
              locationInfo.target_state +
              "',target_dma='" +
              locationInfo.target_dma +
              "',target_counties='" +
              locationInfo.target_counties +
              "',target_postalcode='" +
              locationInfo.target_zipcode +
              "',target_brands='" +
              locationInfo.target_brands +
              "',target_congressional_districts='" +
              locationInfo.target_congressional_districts +
              "',target_senate_districts='" +
              locationInfo.target_senate_districts +
              "',target_house_districts='" +
              locationInfo.target_house_districts +
              "',latlon_radius='" +
              locationInfo.latlon_radius +
              "',addresses_radius='" +
              locationInfo.addresses_radius +
              "',poi_radius='" +
              locationInfo.poi_radius +
              "',min_days='" +
              locationInfo.min_days +
              "',min_visits='" +
              locationInfo.min_visits +
              "',name='" +
              addslashes(locationInfo.name) +
              "',geo_points='" +
              addslashes(locationInfo.target_latlon) +
              "',target_addresses='" +
              addslashes(locationInfo.target_addresses) +
              "',geo_polygons='" +
              addslashes(locationInfo.target_polygon) +
              "',target_poi='" +
              addslashes(locationInfo.target_poi) +
              "',target_latlon_groups='" +
              locationInfo.target_latlon_group +
              "',target_polygon_groups='" +
              locationInfo.target_polygon_group +
              "',target_address_groups='" +
              locationInfo.target_address_group +
              "',updated_date=" +
              DATASOURCE_CONFIG.CURRENT_DATE +
              ",target_email_groups='" +
              addslashes(locationInfo.target_email) +
              "',target_ipaddress_groups='" +
              (locationInfo.target_ipaddress_groups || "") +
              "'  where id='" +
              locationInfo.id +
              "' and audience_id='" +
              audienceId +
              "' ",
            datasource: DATASOURCE_CONFIG.DATASOURCE,
          });
        }
      }
      console.log("InsertQuery", InsertQuery);
      if (InsertValuesArr.length > 0) {
        InsertQuery += InsertValuesArr.join(",");
        queriesArr.push({
          query: InsertQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
    }
    const queryBody = {
      queries: queriesArr,
    };
    console.log("Location queryBody", queryBody);

    try {
      const response = await axiosApiInstance.post(
        `${updateDataEndPoint}`,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetAudienceLocationGroupThunk = createAsyncThunk(
  "audienceManagement/GetAudienceLocationGroupThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    const queryBody = {
      queries: [
        {
          /****get campaign location groups data** */
          query:
            "select * from " +
            tablePrefix +
            "audience_location_groups where audience_id='" +
            payload.id +
            "' and is_active=1",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        `${getDataEndPoint}`,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

/*export const GetAudienceTargetingsByIds = createAsyncThunk(
  "audienceManagement/GetAudienceTargetingsByIds",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    var queriesArr = [];
    for (var i = 0; i < payload.length; i++) {
      var targetInfo = payload[i];
      if (targetInfo.key == "target_city") {
        let targetCityQuery =
          "select concat(concat(concat(concat(country_code, '_'), state_code), '_'), Name),id, latitude as lat, longitude as lng, concat(concat(concat((Name), ' '), state_code), ' (CITY)') as Name,'city' as type from " +
          tablePrefix +
          "cities where id in ('" +
          targetInfo["values"].join("','") +
          "')";
        if (DATASOURCE_CONFIG.DATASOURCE == "mysql") {
          targetCityQuery =
            "select CONCAT(CONCAT(country_code, '_', state_code), '_', NAME) as concat,id, latitude as lat, longitude as lng, concat(concat((Name), ' ', state_code), ' (CITY)') as Name,'city' as type from " +
            tablePrefix +
            "cities where id in ('" +
            targetInfo["values"].join("','") +
            "')";
        }
        queriesArr.push({
          query: targetCityQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_state") {
        queriesArr.push({
          query:
            "select concat(concat(country_code, '_'), iso2) as state_code,id,  concat(name,' (STATE)') as Name, latitude as lat, longitude as lng,'state' as type from " +
            tablePrefix +
            "states where id in ('" +
            targetInfo["values"].join("','") +
            "') ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_dma") {
        queriesArr.push({
          query:
            "select dma_code,dma_code as id, concat(dma_name,' (DMA)') as name,0 as lat,0 as lng,'dma' as type from " +
            tablePrefix +
            "geodma where dma_code in ('" +
            targetInfo["values"].join("','") +
            "')",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_counties") {
        queriesArr.push({
          query:
            "select id as county_code, concat(concat(county_name, ' '), state) as name from " +
            tablePrefix +
            "counties where id in ('" +
            targetInfo["values"].join("','") +
            "')",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "brands") {
        queriesArr.push({
          query:
            "select id as brand_id,id, name,location_count from aggdata.lists where  id in ('" +
            targetInfo["values"].join("','") +
            "')",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_poi") {
        queriesArr.push({
          query:
            "select id as brand_id,id, name as brand,location_count from aggdata.lists where  id in ('" +
            targetInfo["values"].join("','") +
            "')",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_congressional_districts") {
        queriesArr.push({
          query:
            "SELECT dm.id AS id,concat(concat(state_code, '-'), cd116_fip) AS name,0 as lat,0 as lng FROM " +
            tablePrefix +
            "congressional_districts dm where  id in ('" +
            targetInfo["values"].join("','") +
            "') GROUP BY dm.id,dm.state_code, cd116_fip  ORDER BY name",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_senate_districts") {
        queriesArr.push({
          query:
            "SELECT dm.geo_id AS id,concat(concat(state_code, '('), concat(district,')')) AS name ,0 as lat,0 as lng FROM " +
            tablePrefix +
            "state_legislative_districts dm WHERE dm.geo_id in ('" +
            targetInfo["values"].join("','") +
            "') GROUP BY dm.geo_id,dm.state_code,district ORDER BY name;",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
    }

    const queryBody = {
      queries: queriesArr,
    };

    try {
      const response = await axiosApiInstance.post(
        `${getDataEndPoint}`,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
*/

export const GetAudienceLocationChildTablesDataThunk = createAsyncThunk(
  "audienceManagement/GetAudienceLocationChildTablesDataThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    var queriesArr = [];
    for (var i = 0; i < payload.length; i++) {
      var childInfo = payload[i];
      if (childInfo.key == "target_addresses") {
        queriesArr.push({
          query:
            "select addresses as target_addresses,type from " +
            tablePrefix +
            "audience_location_groups_addresses where location_group_id='" +
            childInfo.id +
            "';",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (childInfo.key == "target_latlon") {
        queriesArr.push({
          query:
            "select id,target_latlon_groups as target_latlon,type from " +
            tablePrefix +
            "audience_location_groups_latlon where location_group_id='" +
            childInfo.id +
            "' and is_active='1';",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (childInfo.key == "target_polygon") {
        queriesArr.push({
          query:
            "select id,target_polygon_groups as target_polygon,type from " +
            tablePrefix +
            "audience_location_groups_polygons where location_group_id='" +
            childInfo.id +
            "' and is_active='1';",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (childInfo.key == "target_poi") {
        /*queriesArr.push({
          query:
            "select bd.id as brand_id,bd.id, bd.name as brand,bd.location_count from aggdata.lists as bd,consent.audience_location_groups_poi as poi where  bd.id=poi.target_poi and poi.location_group_id='" +
            childInfo.id +
            "';",
          datasource: "redshift",
        });*/
        queriesArr.push({
          query:
            "select target_poi from " +
            tablePrefix +
            "audience_location_groups_poi  where location_group_id='" +
            childInfo.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
    }
    const queryBody = {
      queries: queriesArr,
    };
    console.log("Child Table Query", queryBody);
    try {
      const response = await axiosApiInstance.post(
        `${getDataEndPoint}`,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const UpdateAudienceStatusThunk = createAsyncThunk(
  "audienceManagement/UpdateAudienceStatusThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    const queryBody = {
      queries: [
        {
          query:
            "update " +
            tablePrefix +
            "audience_segments_providers set is_active='2',updated_at=" +
            DATASOURCE_CONFIG.CURRENT_DATE +
            " where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetAllProviderListThunk = createAsyncThunk(
  "audienceManagement/GetAllProviderListThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    const queryBody = {
      queries: [
        {
          query:
            "SELECT code as value,name as label from " +
            tablePrefix +
            "audience_provider_details where is_external=1",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const CheckSegmentNameAvailabilityThunk = createAsyncThunk(
  "audienceManagement/CheckSegmentNameAvailabilityThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    const queryBody = {
      queries: [
        {
          query:
            "Select segment from " +
            tablePrefix +
            "audience_segments_providers where segment_name='" +
            payload.name +
            "' ", ///and provider='microssp'
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetContextualCategoriesListThunk = createAsyncThunk(
  "audienceManagement/GetContextualCategoriesListThunk",
  async (payload) => {
    let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
    const queryBody = {
      queries: [
        {
          query: "select id,name from " + tablePrefix + "iab_taxonomy_v3",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      // console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

//Sid POI/Places New:

export const GetPoiItemUniquesThunk = createAsyncThunk(
  "audienceManagement/GetPoiItemUniquesThunk",
  async (payload) => {
    let geohash = payload.geohash;
    let privateAccounts = payload.private_accounts;

    // Get current UTC time
    const now = moment.utc();

    // Get the current hour in UTC
    const currentHour = now.hour();

    // Determine the date based on the hour
    let dateToReturn;

    if (currentHour >= 5) {
      // If time is more than or equal to 5th hour, get yesterday's date
      dateToReturn = now.subtract(1, "day").format("YYYY-MM-DD");
    } else {
      // If time is less than the 5th hour, get the day before yesterday's date
      dateToReturn = now.subtract(2, "days").format("YYYY-MM-DD");
    }

    dateToReturn = dateToReturn + " 00:00:00";
    console.log("dateToReturn:", dateToReturn);

    let accountIdsWhr = "";
    if (privateAccounts.length > 0) {
      accountIdsWhr =
        " and accountid NOT IN('" + privateAccounts.join("','") + "')";
    }

    const queryBody = {
      queries: [
        {
          query:
            "select sum(uniques) as uniques,sum(requests) as requests from neptune.supply_partition_files_path_info where date_time = '" +
            dateToReturn +
            "' and geohash IN('" +
            geohash +
            "') " +
            accountIdsWhr +
            " group by geohash",
          datasource: "redshift",
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        getReportingDataEndPoint,
        queryBody
      );
      // console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetPoiItemDetailsByIDThunk = createAsyncThunk(
  "audienceManagement/GetPoiItemDetailsByIDThunk",
  async (payload) => {
    let selectedPoi = payload.id;

    let Where = [];
    let selectedPoiStr = "";
    if (selectedPoi.length > 0) {
      selectedPoiStr = "'" + selectedPoi.join("','") + "'";
    }

    if (
      selectedPoiStr != null &&
      selectedPoiStr != "" &&
      selectedPoiStr != undefined
    ) {
      Where.push(" and id IN (" + selectedPoiStr + ")");
    }

    let WhereStr = "";
    if (Where.length > 0) {
      WhereStr = Where.join("");
    }

    let finalQuery =
      "select id,chain_name,store_name,full_address,city_name,region_code,postal_code,latitude,longitude,1 as active,geo_hash from mn.mn_places where permanently_closed=0 " +
      WhereStr +
      " ";

    let queriesArr = [];

    queriesArr.push({
      query: finalQuery,
      datasource: "redshift",
    });

    const queryBody = {
      queries: queriesArr,
    };
    try {
      const response = await axiosApiInstance.post(
        getReportingDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const SearchPoiLocationsThunk = createAsyncThunk(
  "audienceManagement/SearchPoiLocationsThunk",
  async (payload) => {
    var country = payload.cc;
    let loc_type = payload.loc_type;
    var searchText = payload.q;
    let page = payload.page;

    let Where = "";
    // let selPOI = [];
    // var selectedValuesArr = payload?.selValue ? payload?.selValue : [];
    // for (let x = 0; x < selectedValuesArr.length; x++) {
    //   let info = selectedValuesArr[x];
    //   if (info?.id) {
    //     selPOI.push(info.id);
    //   }
    // }

    // Where =
    //   selPOI.length > 0 ? " and id NOT IN('" + selPOI.join("','") + "')" : "";

    // let stateQry =
    //   "select concat('region_code:::',region_code) as id, region_code as location from mn.mn_places where country_code = '" +
    //   country +
    //   "' and region_code = '" +
    //   addslashes(searchText.toUpperCase()) +
    //   "' and permanently_closed=0 group by region_code ";

    let stateQry =
      "SELECT CONCAT('state@@@',s.`iso2`,':::region_code:::',s.name) AS id,CONCAT(s.name,' [',s.iso2,']') AS location from states s,countries c  WHERE s.country_code = '" +
      country +
      "' AND s.`country_code`=c.iso2 AND (s.name like '" +
      searchText +
      "%'  OR s.iso2 like '" +
      searchText +
      "%')";

    // let citiesQry =
    //   "select ('city_name:::' || city_name || '@@@' || 'region_code:::' || nvl(region_code,'')) as id, (city_name || ', ' || nvl(region_code,'')) as location from mn.mn_places where country_code = '" +
    //   country +
    //   "' and city_name ilike '%" +
    //   addslashes(searchText) +
    //   "%' and permanently_closed=0 group by city_name,region_code ";

    let citiesQry =
      "SELECT CONCAT('city@@@','city_name:::',s.name,'@@@region_code:::',s.`state_code`,'@@@region_name:::',st.name) AS id,concat((s.name), ' [',st.name,' - ',s.state_code,']') as location " +
      " from cities s,countries c,states st WHERE s.country_code = '" +
      country +
      "' AND s.`country_code`=c.iso2 AND s.name like '" +
      addslashes(searchText) +
      "%' and st.iso2=s.state_code AND st.country_code = '" +
      country +
      "' ";

    let postalQry =
      "select ('postal_code:::' || postal_code) as id, postal_code as location  from mn.mn_places where country_code = '" +
      country +
      "' and postal_code = '" +
      addslashes(searchText) +
      "' and permanently_closed=0 group by postal_code ";

    let dmaQry =
      "select ('dma_code:::' || dma_code) as id, ('' || dma_code) as location  from mn.mn_places where country_code = '" +
      country +
      "' and dma_code ilike '%" +
      addslashes(searchText) +
      "%' and permanently_closed=0 group by dma_code ";

    let addressQry =
      "select ('full_address:::' || full_address || '@@@' || 'city_name:::' || nvl(city_name,'') || '@@@' || 'region_code:::' || nvl(region_code,'')) as id, (full_address || ', ' || nvl(city_name,'') || ', ' || nvl(region_code,'')) as location  from mn.mn_places where country_code = '" +
      country +
      "' and full_address ilike '%" +
      addslashes(searchText) +
      "%' and permanently_closed=0 group by full_address,city_name,region_code ";

    let finalQuery = "";
    if (loc_type == "all") {
      finalQuery =
        "(" +
        addressQry +
        ") UNION (" +
        citiesQry +
        ") UNION (" +
        postalQry +
        ") UNION (" +
        stateQry +
        ") UNION (" +
        dmaQry +
        ")";
      //$unionQuery=$stateQry.' UNION '.$dmaQry;
    } else if (loc_type == "state") {
      finalQuery = stateQry;
    } else if (loc_type == "city") {
      finalQuery = citiesQry;
    } else if (loc_type == "dma") {
      finalQuery = dmaQry;
    } else if (loc_type == "address") {
      finalQuery = addressQry;
    } else if (loc_type == "postalcode") {
      finalQuery = postalQry;
    }

    if (page > 0) {
      page -= 1;
      let perPage = 100;
      let start = page * perPage;
      finalQuery = finalQuery + " LIMIT " + perPage + " OFFSET " + start;
    }

    const queryBody = {
      queries: [
        {
          query: finalQuery,
          datasource:
            loc_type == "state" || loc_type == "city" ? "mysql" : "redshift",
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        getReportingDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const SearchPoiChainNamesThunk = createAsyncThunk(
  "audienceManagement/SearchPoiChainNamesThunk",
  async (payload) => {
    var country = payload.cc;
    var searchText = payload.q;
    let page = payload.page;
    let multiloc = payload.multiloc;

    let Where = [];
    if (country != "" && country != null && country != undefined) {
      Where.push(" and country_code = '" + country + "' ");
    }

    if (multiloc != null && multiloc != "" && multiloc != undefined) {
      //Handle Separately if it is state/city
      if (multiloc.indexOf("state@@@") != -1) {
        let floc = multiloc.replace("state@@@", "");
        let flocArr = floc.split(":::region_code:::");
        let fstateCode = flocArr[0];
        let fstateName = flocArr[1];
        let fstateCodeQry =
          fstateCode == "" || fstateCode == null
            ? "(region_code is NULL OR region_code='')"
            : "(region_code ='" + fstateCode + "')";
        let fstateNameQry =
          fstateName == "" || fstateName == null
            ? "(region_code is NULL OR region_code='')"
            : "(region_code ilike '" + fstateName + "')";

        Where.push(" and (" + fstateCodeQry + " OR " + fstateNameQry + ")");
      } else if (multiloc.indexOf("city@@@") != -1) {
        let floc = multiloc.replace("city@@@", "");
        let flocArr = floc.split("@@@");
        let cityName = flocArr[0].replace("city_name:::", "");
        let regionCode = flocArr[1].replace("region_code:::", "");
        let regionName = flocArr[2].replace("region_name:::", "");

        //Region Code
        let fstateCodeQry =
          regionCode == "" || regionCode == null
            ? "(region_code is NULL OR region_code='')"
            : "(region_code ='" + regionCode + "')";
        let fstateNameQry =
          regionName == "" || regionName == null
            ? "(region_code is NULL OR region_code='')"
            : "(region_code ilike '" + regionName + "')";

        Where.push(" and (" + fstateCodeQry + " OR " + fstateNameQry + ")");

        //City Name
        let fcityNameQry =
          cityName == "" || cityName == null
            ? "(city_name is NULL OR city_name='')"
            : "(city_name ilike '" + cityName + "')";
        Where.push(" and (" + fcityNameQry + ")");
      } else {
        let at = multiloc.split("@@@");
        for (let k = 0; k < at.length; k++) {
          let tp = at[k].split(":::");
          if (tp[1] == "" || tp[1] == null) {
            Where.push(" and (" + tp[0] + " is NULL OR " + tp[0] + "='') ");
          } else {
            Where.push(" and " + tp[0] + " ilike '" + tp[1] + "%' ");
          }
        }
      }
    }

    let WhereStr = "";
    if (Where.length > 0) {
      WhereStr = Where.join("");
    }
    let finalQuery =
      "select distinct chain_name from mn.mn_places where chain_name ilike '%" +
      addslashes(searchText) +
      "%' " +
      WhereStr +
      " and permanently_closed=0";

    if (page > 0) {
      page -= 1;
      let perPage = 100;
      let start = page * perPage;
      finalQuery = finalQuery + " LIMIT " + perPage + " OFFSET " + start;
    }

    const queryBody = {
      queries: [
        {
          query: finalQuery,
          datasource: "redshift",
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        getReportingDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const SearchPoiDataListThunk = createAsyncThunk(
  "audienceManagement/SearchPoiDataListThunk",
  async (payload) => {
    let country = payload.selCountry;
    let selLocation = payload.selLocation;
    let selChain = payload.selChain;
    let page = payload.page;
    let perPage = payload.perPage;
    let selectedPoi = payload.selectedPoi;

    let Where = [];
    if (country != "" && country != null && country != undefined) {
      Where.push(" and country_code = '" + country + "' ");
    }

    if (selChain != "" && selChain != null && selChain != undefined) {
      Where.push(" and chain_name ilike '" + addslashes(selChain) + "' ");
    }

    if (selLocation != null && selLocation != "" && selLocation != undefined) {
      //Handle Separately if it is state/city
      if (selLocation.indexOf("state@@@") != -1) {
        let floc = selLocation.replace("state@@@", "");
        let flocArr = floc.split(":::region_code:::");
        let fstateCode = flocArr[0];
        let fstateName = flocArr[1];
        let fstateCodeQry =
          fstateCode == "" || fstateCode == null
            ? "(region_code is NULL OR region_code='')"
            : "(region_code ='" + fstateCode + "')";
        let fstateNameQry =
          fstateName == "" || fstateName == null
            ? "(region_code is NULL OR region_code='')"
            : "(region_code ilike '" + fstateName + "')";

        Where.push(" and (" + fstateCodeQry + " OR " + fstateNameQry + ")");
      } else if (selLocation.indexOf("city@@@") != -1) {
        let floc = selLocation.replace("city@@@", "");
        let flocArr = floc.split("@@@");
        let cityName = flocArr[0].replace("city_name:::", "");
        let regionCode = flocArr[1].replace("region_code:::", "");
        let regionName = flocArr[2].replace("region_name:::", "");

        //Region Code
        let fstateCodeQry =
          regionCode == "" || regionCode == null
            ? "(region_code is NULL OR region_code='')"
            : "(region_code ='" + regionCode + "')";
        let fstateNameQry =
          regionName == "" || regionName == null
            ? "(region_code is NULL OR region_code='')"
            : "(region_code ilike '" + regionName + "')";

        Where.push(" and (" + fstateCodeQry + " OR " + fstateNameQry + ")");

        //City Name
        let fcityNameQry =
          cityName == "" || cityName == null
            ? "(city_name is NULL OR city_name='')"
            : "(city_name ilike '" + cityName + "')";
        Where.push(" and (" + fcityNameQry + ")");
      } else {
        let at = selLocation.split("@@@");
        for (let k = 0; k < at.length; k++) {
          let tp = at[k].split(":::");
          if (tp[1] == "" || tp[1] == null) {
            Where.push(" and (" + tp[0] + " is NULL OR " + tp[0] + "='') ");
          } else {
            Where.push(" and " + tp[0] + " ilike '" + tp[1] + "' ");
          }
        }
      }
    }

    let selectedPoiStr = "";
    if (selectedPoi.length > 0) {
      selectedPoiStr = "'" + selectedPoi.join("','") + "'";
    }

    if (
      selectedPoiStr != null &&
      selectedPoiStr != "" &&
      selectedPoiStr != undefined
    ) {
      Where.push(" and id NOT IN (" + selectedPoiStr + ")");
    }

    let WhereStr = "";
    if (Where.length > 0) {
      WhereStr = Where.join("");
    }

    let cQuery = "";
    if (page == 1) {
      cQuery =
        "select  count(*) as total from mn.mn_places where permanently_closed=0 " +
        WhereStr +
        " ";
    }

    let finalQuery =
      "select id,chain_name,store_name,full_address,city_name,region_code,postal_code,latitude,longitude,1 as active,geo_hash from mn.mn_places where permanently_closed=0 " +
      WhereStr +
      " ";

    if (page > 0) {
      page -= 1;

      let start = page * perPage;
      finalQuery =
        finalQuery + " order by id LIMIT " + perPage + " OFFSET " + start;
    }

    let queriesArr = [];
    if (cQuery != "") {
      queriesArr.push({ query: cQuery, datasource: "redshift" });
    }
    queriesArr.push({
      query: finalQuery,
      datasource: "redshift",
    });

    const queryBody = {
      queries: queriesArr,
    };
    try {
      const response = await axiosApiInstance.post(
        getReportingDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

//------For Attribution---------

export const SearchAttrLocationsThunk = createAsyncThunk(
  "audienceManagement/SearchAttrLocationsThunk",
  async (payload) => {
    var country = payload.cc;
    let loc_type = payload.loc_type;
    var searchText = payload.q;
    let page = payload.page;

    let Where = "";
    // let selPOI = [];
    // var selectedValuesArr = payload?.selValue ? payload?.selValue : [];
    // for (let x = 0; x < selectedValuesArr.length; x++) {
    //   let info = selectedValuesArr[x];
    //   if (info?.id) {
    //     selPOI.push(info.id);
    //   }
    // }

    // Where =
    //   selPOI.length > 0 ? " and id NOT IN('" + selPOI.join("','") + "')" : "";

    // let stateQry =
    //   "select concat('region_code:::',region_code) as id, region_code as location from mn.mn_places where country_code = '" +
    //   country +
    //   "' and region_code = '" +
    //   addslashes(searchText.toUpperCase()) +
    //   "' and permanently_closed=0 group by region_code ";

    // let citiesQry =
    //   "select ('city_name:::' || city_name || '@@@' || 'region_code:::' || nvl(region_code,'')) as id, (city_name || ', ' || nvl(region_code,'')) as location from mn.mn_places where country_code = '" +
    //   country +
    //   "' and city_name ilike '%" +
    //   addslashes(searchText) +
    //   "%' and permanently_closed=0 group by city_name,region_code ";

    let stateQry =
      "SELECT CONCAT('state@@@',s.`iso2`,':::region_code:::',s.name) AS id,CONCAT(s.name,' [',s.iso2,']') AS location from states s,countries c  WHERE s.country_code = '" +
      country +
      "' AND s.`country_code`=c.iso2 AND (s.name like '" +
      searchText +
      "%'  OR s.iso2 like '" +
      searchText +
      "%')";

    let citiesQry =
      "SELECT CONCAT('city@@@','city_name:::',s.name,'@@@region_code:::',s.`state_code`,'@@@region_name:::',st.name) AS id,concat((s.name), ' [',st.name,' - ',s.state_code,']') as location " +
      " from cities s,countries c,states st WHERE s.country_code = '" +
      country +
      "' AND s.`country_code`=c.iso2 AND s.name like '" +
      addslashes(searchText) +
      "%' and st.iso2=s.state_code AND st.country_code = '" +
      country +
      "' ";

    let postalQry =
      "select ('postal_code:::' || postal_code) as id, postal_code as location  from mn.mn_places where country_code = '" +
      country +
      "' and postal_code = '" +
      addslashes(searchText) +
      "' and permanently_closed=0 group by postal_code ";

    let dmaQry =
      "select ('dma_code:::' || dma_code) as id, ('' || dma_code) as location  from mn.mn_places where country_code = '" +
      country +
      "' and dma_code ilike '" +
      addslashes(searchText) +
      "' and permanently_closed=0 group by dma_code ";

    let addressQry =
      "select ('full_address:::' || full_address || '@@@' || 'city_name:::' || nvl(city_name,'') || '@@@' || 'region_code:::' || nvl(region_code,'')) as id, (full_address || ', ' || nvl(city_name,'') || ', ' || nvl(region_code,'')) as location  from mn.mn_places where country_code = '" +
      country +
      "' and full_address ilike '%" +
      addslashes(searchText) +
      "%' and permanently_closed=0 group by full_address,city_name,region_code ";

    let finalQuery = "";
    if (loc_type == "all") {
      finalQuery =
        "(" +
        addressQry +
        ") UNION (" +
        citiesQry +
        ") UNION (" +
        postalQry +
        ") UNION (" +
        stateQry +
        ") UNION (" +
        dmaQry +
        ")";
      //$unionQuery=$stateQry.' UNION '.$dmaQry;
    } else if (loc_type == "state") {
      finalQuery = stateQry;
    } else if (loc_type == "city") {
      finalQuery = citiesQry;
    } else if (loc_type == "dma") {
      finalQuery = dmaQry;
    } else if (loc_type == "address") {
      finalQuery = addressQry;
    } else if (loc_type == "postalcode") {
      finalQuery = postalQry;
    }

    if (page > 0) {
      page -= 1;
      let perPage = 100;
      let start = page * perPage;
      finalQuery = finalQuery + " LIMIT " + perPage + " OFFSET " + start;
    }

    const queryBody = {
      queries: [
        {
          query: finalQuery,
          datasource:
            loc_type == "state" || loc_type == "city" ? "mysql" : "redshift",
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        getReportingDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const SearchAttrChainNamesThunk = createAsyncThunk(
  "audienceManagement/SearchAttrChainNamesThunk",
  async (payload) => {
    var country = payload.cc;
    var searchText = payload.q;
    let page = payload.page;
    let multiloc = payload.multiloc;

    let Where = [];
    if (country != "" && country != null && country != undefined) {
      Where.push(" and country_code = '" + country + "' ");
    }

    // if (multiloc != null && multiloc != "" && multiloc != undefined) {
    //   let at = multiloc.split("@@@");
    //   for (let k = 0; k < at.length; k++) {
    //     let tp = at[k].split(":::");
    //     if (tp[1] == "" || tp[1] == null) {
    //       Where.push(" and (" + tp[0] + " is NULL OR " + tp[0] + "='') ");
    //     } else {
    //       Where.push(" and " + tp[0] + " ilike '" + tp[1] + "' ");
    //     }
    //   }
    // }

    if (multiloc != null && multiloc != "" && multiloc != undefined) {
      //Handle Separately if it is state/city
      if (multiloc.indexOf("state@@@") != -1) {
        let floc = multiloc.replace("state@@@", "");
        let flocArr = floc.split(":::region_code:::");
        let fstateCode = flocArr[0];
        let fstateName = flocArr[1];
        let fstateCodeQry =
          fstateCode == "" || fstateCode == null
            ? "(region_code is NULL OR region_code='')"
            : "(region_code ='" + fstateCode + "')";
        let fstateNameQry =
          fstateName == "" || fstateName == null
            ? "(region_code is NULL OR region_code='')"
            : "(region_code ilike '" + fstateName + "')";

        Where.push(" and (" + fstateCodeQry + " OR " + fstateNameQry + ")");
      } else if (multiloc.indexOf("city@@@") != -1) {
        let floc = multiloc.replace("city@@@", "");
        let flocArr = floc.split("@@@");
        let cityName = flocArr[0].replace("city_name:::", "");
        let regionCode = flocArr[1].replace("region_code:::", "");
        let regionName = flocArr[2].replace("region_name:::", "");

        //Region Code
        let fstateCodeQry =
          regionCode == "" || regionCode == null
            ? "(region_code is NULL OR region_code='')"
            : "(region_code ='" + regionCode + "')";
        let fstateNameQry =
          regionName == "" || regionName == null
            ? "(region_code is NULL OR region_code='')"
            : "(region_code ilike '" + regionName + "')";

        Where.push(" and (" + fstateCodeQry + " OR " + fstateNameQry + ")");

        //City Name
        let fcityNameQry =
          cityName == "" || cityName == null
            ? "(city_name is NULL OR city_name='')"
            : "(city_name ilike '" + cityName + "')";
        Where.push(" and (" + fcityNameQry + ")");
      } else {
        let at = multiloc.split("@@@");
        for (let k = 0; k < at.length; k++) {
          let tp = at[k].split(":::");
          if (tp[1] == "" || tp[1] == null) {
            Where.push(" and (" + tp[0] + " is NULL OR " + tp[0] + "='') ");
          } else {
            Where.push(" and " + tp[0] + " ilike '" + tp[1] + "%' ");
          }
        }
      }
    }

    let WhereStr = "";
    if (Where.length > 0) {
      WhereStr = Where.join("");
    }
    let finalQuery =
      "select distinct chain_name from mn.mn_places where chain_name ilike '%" +
      addslashes(searchText) +
      "%' " +
      WhereStr +
      " and permanently_closed=0";

    if (page > 0) {
      page -= 1;
      let perPage = 100;
      let start = page * perPage;
      finalQuery = finalQuery + " LIMIT " + perPage + " OFFSET " + start;
    }

    const queryBody = {
      queries: [
        {
          query: finalQuery,
          datasource: "redshift",
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        getReportingDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const SearchAttrDataListThunk = createAsyncThunk(
  "audienceManagement/SearchAttrDataListThunk",
  async (payload) => {
    let country = payload.selCountry;
    let selLocation = payload.selLocation;
    let selChain = payload.selChain;
    let page = payload.page;
    let perPage = payload.perPage;
    let selectedPoi = payload.selectedPoi;

    let Where = [];
    if (country != "" && country != null && country != undefined) {
      Where.push(" and country_code = '" + country + "' ");
    }

    if (selChain != "" && selChain != null && selChain != undefined) {
      Where.push(" and chain_name ilike '" + addslashes(selChain) + "' ");
    }

    // if (selLocation != null && selLocation != "" && selLocation != undefined) {
    //   let at = selLocation.split("@@@");
    //   for (let k = 0; k < at.length; k++) {
    //     let tp = at[k].split(":::");
    //     if (tp[1] == "" || tp[1] == null) {
    //       Where.push(" and (" + tp[0] + " is NULL OR " + tp[0] + "='') ");
    //     } else {
    //       Where.push(" and " + tp[0] + " ilike '" + tp[1] + "' ");
    //     }
    //   }
    // }

    if (selLocation != null && selLocation != "" && selLocation != undefined) {
      //Handle Separately if it is state/city
      if (selLocation.indexOf("state@@@") != -1) {
        let floc = selLocation.replace("state@@@", "");
        let flocArr = floc.split(":::region_code:::");
        let fstateCode = flocArr[0];
        let fstateName = flocArr[1];
        let fstateCodeQry =
          fstateCode == "" || fstateCode == null
            ? "(region_code is NULL OR region_code='')"
            : "(region_code ='" + fstateCode + "')";
        let fstateNameQry =
          fstateName == "" || fstateName == null
            ? "(region_code is NULL OR region_code='')"
            : "(region_code ilike '" + fstateName + "')";

        Where.push(" and (" + fstateCodeQry + " OR " + fstateNameQry + ")");
      } else if (selLocation.indexOf("city@@@") != -1) {
        let floc = selLocation.replace("city@@@", "");
        let flocArr = floc.split("@@@");
        let cityName = flocArr[0].replace("city_name:::", "");
        let regionCode = flocArr[1].replace("region_code:::", "");
        let regionName = flocArr[2].replace("region_name:::", "");

        //Region Code
        let fstateCodeQry =
          regionCode == "" || regionCode == null
            ? "(region_code is NULL OR region_code='')"
            : "(region_code ='" + regionCode + "')";
        let fstateNameQry =
          regionName == "" || regionName == null
            ? "(region_code is NULL OR region_code='')"
            : "(region_code ilike '" + regionName + "')";

        Where.push(" and (" + fstateCodeQry + " OR " + fstateNameQry + ")");

        //City Name
        let fcityNameQry =
          cityName == "" || cityName == null
            ? "(city_name is NULL OR city_name='')"
            : "(city_name ilike '" + cityName + "')";
        Where.push(" and (" + fcityNameQry + ")");
      } else {
        let at = selLocation.split("@@@");
        for (let k = 0; k < at.length; k++) {
          let tp = at[k].split(":::");
          if (tp[1] == "" || tp[1] == null) {
            Where.push(" and (" + tp[0] + " is NULL OR " + tp[0] + "='') ");
          } else {
            Where.push(" and " + tp[0] + " ilike '" + tp[1] + "' ");
          }
        }
      }
    }

    let selectedPoiStr = "";
    if (selectedPoi.length > 0) {
      selectedPoiStr = "'" + selectedPoi.join("','") + "'";
    }

    if (
      selectedPoiStr != null &&
      selectedPoiStr != "" &&
      selectedPoiStr != undefined
    ) {
      Where.push(" and id NOT IN (" + selectedPoiStr + ")");
    }

    let WhereStr = "";
    if (Where.length > 0) {
      WhereStr = Where.join("");
    }

    let cQuery = "";
    if (page == 1) {
      cQuery =
        "select  count(*) as total from mn.mn_places where permanently_closed=0 " +
        WhereStr +
        " ";
    }

    let finalQuery =
      "select id,chain_name,store_name,full_address,city_name,region_code,postal_code,latitude,longitude,geo_polygon_rev as polygon,1 as active from mn.mn_places where permanently_closed=0 " +
      WhereStr +
      " ";

    if (page > 0) {
      page -= 1;

      let start = page * perPage;
      finalQuery =
        finalQuery + " order by id LIMIT " + perPage + " OFFSET " + start;
    }

    let queriesArr = [];
    if (cQuery != "") {
      queriesArr.push({ query: cQuery, datasource: "redshift" });
    }
    queriesArr.push({
      query: finalQuery,
      datasource: "redshift",
    });

    const queryBody = {
      queries: queriesArr,
    };
    try {
      const response = await axiosApiInstance.post(
        getReportingDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const getSegmentGeoHashInfo = createAsyncThunk(
  "audienceManagement/getSegmentGeoHashInfo",
  async (payload) => {
    try {
      const response = await axiosApiInstance.post(
        getSegmentGeoHashInfoApiUrl,
        {
          segment: payload.segment,
        }
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

const AudienceManagement = createSlice({
  name: "audienceManagement",
  initialState,
  reducers: {
    resetCountryDependencyList(state, action) {
      state.CityStateDMAList = [];
      state.POIList = [];
      state.POILocationsList = [];
      state.AttrLocationsList = [];
      state.POIChainNamesList = [];
      state.AttrChainNamesList = [];
      state.POIDataList = {};
      state.AttrDataList = {};
      state.BrandsList = [];
      state.KMLList = [];
      state.CongressionalDistrictsList = [];
      state.SenateDistrictsList = [];
      state.HouseDistrictsList = [];
      state.CountiesList = [];
    },
    resetPlacementsListData(state, action) {
      state.PlacementIdsList = [];
    },
    updateSegmentFiltersFormValues(state, action) {
      let segmentFilters = cloneDeep(state.segmentFilterFormValues);
      if (action.payload?.action == "delete") {
        segmentFilters = {
          accounts: [],
          segmenttypes: [],
        };
      } else {
        let type = action.payload.type;
        let data = action.payload.data;
        segmentFilters[type] = data;
      }

      state.segmentFilterFormValues = segmentFilters;
    },
    updateSegmentFilters(state, action) {
      let segmentFilters = cloneDeep(state.segmentFilters);
      segmentFilters.accounts = action.payload.accounts;
      segmentFilters.segmenttypes = action.payload.segmenttypes;
      state.segmentFilters = segmentFilters;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllTargetingTypesAndOptions.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllTargetingTypesAndOptions.fulfilled, (state, action) => {
        //let data = action.payload.data.results;
        if (action.payload.data?.results?.length > 0) {
          //targetingTypesAndOption
          let data = action.payload.data.results[0];

          console.log("data", data);
          state.targetingTypesAndOption = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.loading = false;
      })
      .addCase(GetAllTargetingTypesAndOptions.rejected, (state, action) => {
        toast.error("Something went Wrong!");
      })
      .addCase(GetAllCountriesListThunk.pending, (state) => {
        state.loading = true;
        state.isCountriesLoaded = false;
      })
      .addCase(GetAllCountriesListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
          let rowtData = { name: "ROTW", id: "ROTW" };
          data.push(rowtData);
          state.countriesList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.isCountriesLoaded = true;
        state.loading = false;
      })
      .addCase(GetAllCountriesListThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
      })
      .addCase(GetAllCityStateDMAListThunk.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(GetAllCityStateDMAListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          //let data = action.payload.data.results.flat(1);
          let data = action.payload.data.results[0];

          state.CityStateDMAList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.searchLoading = false;
      })
      .addCase(GetAllCityStateDMAListThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
        state.searchLoading = false;
      })
      .addCase(GetAllStateListThunk.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(GetAllStateListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];

          state.TargetStatesList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.searchLoading = false;
      })
      .addCase(GetAllStateListThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
        state.searchLoading = false;
      })
      .addCase(GetAllDMAListThunk.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(GetAllDMAListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];

          state.DMAList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.searchLoading = false;
      })
      .addCase(GetAllDMAListThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
        state.searchLoading = false;
      })
      .addCase(GetAllCountiesListThunk.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(GetAllCountiesListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];

          state.CountiesList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.searchLoading = false;
      })
      .addCase(GetAllCountiesListThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
        state.searchLoading = false;
      })
      .addCase(GetAllPOIListThunk.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(GetAllPOIListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];

          state.POIList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.searchLoading = false;
      })
      .addCase(GetAllPOIListThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
        state.searchLoading = false;
      })

      .addCase(SearchPoiLocationsThunk.pending, (state) => {
        state.searchLoading = true;
        state.POILocationsList = [];
      })
      .addCase(SearchPoiLocationsThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
          console.log("data:", data);
          state.POILocationsList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.searchLoading = false;
      })
      .addCase(SearchPoiLocationsThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
        state.searchLoading = false;
      })

      .addCase(SearchPoiChainNamesThunk.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(SearchPoiChainNamesThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
          //console.log("data:", data);
          state.POIChainNamesList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.searchLoading = false;
      })
      .addCase(SearchPoiChainNamesThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
        state.searchLoading = false;
      })

      .addCase(SearchPoiDataListThunk.pending, (state, action) => {
        state.searchPOILoading = true;
        let currentPage = action.meta.arg.page;
        if (currentPage == 1) {
          state.POIDataList = {};
        }
      })
      .addCase(SearchPoiDataListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = [];
          let currentPOIDataList = {};
          let currentPage = action.meta.arg.page;
          if (currentPage == 1 && action.payload.data?.results?.length > 1) {
            let countDataArr = action.payload.data.results[0];
            let totalCount = countDataArr?.[0]?.total
              ? countDataArr?.[0]?.total
              : 0;
            state.POIDataListTotalCount = totalCount;

            data = action.payload.data.results[1];
            if (totalCount > 0) {
              currentPOIDataList["total"] = totalCount;
            }

            if (data.length > 0) {
              currentPOIDataList["page_" + currentPage] = data;
            }
            state.POIDataList = currentPOIDataList;
          } else {
            data = action.payload.data.results[0];
            currentPOIDataList = cloneDeep(state.POIDataList);
            currentPOIDataList["page_" + currentPage] = data;
            state.POIDataList = currentPOIDataList;
          }
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.searchPOILoading = false;
      })
      .addCase(SearchPoiDataListThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
        state.searchPOILoading = false;
      })

      //-----attribution-----------------------------

      .addCase(SearchAttrLocationsThunk.pending, (state) => {
        state.searchLoading = true;
        state.AttrLocationsList = [];
      })
      .addCase(SearchAttrLocationsThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
          //console.log("data:", data);
          state.AttrLocationsList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.searchLoading = false;
      })
      .addCase(SearchAttrLocationsThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
        state.searchLoading = false;
      })

      .addCase(SearchAttrChainNamesThunk.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(SearchAttrChainNamesThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
          //console.log("data:", data);
          state.AttrChainNamesList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.searchLoading = false;
      })
      .addCase(SearchAttrChainNamesThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
        state.searchLoading = false;
      })

      .addCase(SearchAttrDataListThunk.pending, (state, action) => {
        state.searchAttrLoading = true;
        let currentPage = action.meta.arg.page;
        if (currentPage == 1) {
          state.AttrDataList = {};
        }
      })
      .addCase(SearchAttrDataListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = [];
          let currentAttrDataList = {};
          let currentPage = action.meta.arg.page;
          if (currentPage == 1 && action.payload.data?.results?.length > 1) {
            let countDataArr = action.payload.data.results[0];
            let totalCount = countDataArr?.[0]?.total
              ? countDataArr?.[0]?.total
              : 0;
            state.AttrDataListTotalCount = totalCount;

            data = action.payload.data.results[1];
            if (totalCount > 0) {
              currentAttrDataList["total"] = totalCount;
            }

            if (data.length > 0) {
              currentAttrDataList["page_" + currentPage] = data;
            }
            state.AttrDataList = currentAttrDataList;
          } else {
            data = action.payload.data.results[0];
            currentAttrDataList = cloneDeep(state.AttrDataList);
            currentAttrDataList["page_" + currentPage] = data;
            state.AttrDataList = currentAttrDataList;
          }
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.searchAttrLoading = false;
      })
      .addCase(SearchAttrDataListThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
        state.searchAttrLoading = false;
      })

      //------attribution end----

      .addCase(GetAllBrandsListThunk.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(GetAllBrandsListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];

          state.BrandsList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.searchLoading = false;
      })
      .addCase(GetAllBrandsListThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
        state.searchLoading = false;
      })
      .addCase(GetAllCongressionalDistrictsListThunk.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(
        GetAllCongressionalDistrictsListThunk.fulfilled,
        (state, action) => {
          if (action.payload.data?.results?.length > 0) {
            let data = action.payload.data.results[0];

            state.CongressionalDistrictsList = data;
          } else if (action.payload.data.status == 0) {
            // toast.error(action.payload.data.message);
          }
          state.searchLoading = false;
        }
      )
      .addCase(
        GetAllCongressionalDistrictsListThunk.rejected,
        (state, action) => {
          toast.error("Something went Wrong!");
          state.searchLoading = false;
        }
      )
      .addCase(GetAllSenateDistrictsListThunk.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(GetAllSenateDistrictsListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];

          state.SenateDistrictsList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.searchLoading = false;
      })
      .addCase(GetAllSenateDistrictsListThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
        state.searchLoading = false;
      })
      .addCase(GetAllHouseDistrictsListThunk.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(GetAllHouseDistrictsListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];

          state.HouseDistrictsList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.searchLoading = false;
      })
      .addCase(GetAllHouseDistrictsListThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
        state.searchLoading = false;
      })
      .addCase(GetPlacementIdsListThunk.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(GetPlacementIdsListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];

          state.PlacementIdsList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.searchLoading = false;
      })
      .addCase(GetPlacementIdsListThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
        state.searchLoading = false;
      })
      .addCase(GetSupplyDealIdsListThunk.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(GetSupplyDealIdsListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
          state.SupplyDealIdsList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.searchLoading = false;
      })
      .addCase(GetSupplyDealIdsListThunk.rejected, (state, action) => {
        state.searchLoading = false;
      })
      /***** GET BUNDLE ID LIST THUNK - start */
      .addCase(GetBundleIdsListThunk.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(GetBundleIdsListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
          state.BundleIdsList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.searchLoading = false;
      })
      .addCase(GetBundleIdsListThunk.rejected, (state, action) => {
        state.searchLoading = false;
      })
      /***** GET BUNDLE ID LIST THUNK - end */
      .addCase(GetPublishersListThunk.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(GetPublishersListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];

          state.PublishersList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.searchLoading = false;
      })
      .addCase(GetPublishersListThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
      })
      .addCase(GetCategoriesListThunk.pending, (state) => {
        state.searchLoading = true;
        state.isCategoriesLoaded = false;
      })
      .addCase(GetCategoriesListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];

          state.CategoriesList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.isCategoriesLoaded = true;
        state.searchLoading = false;
      })
      .addCase(GetCategoriesListThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
      })
      .addCase(GetStatesListByCountryCodeThunk.pending, (state) => {
        state.statesLoading = true;
      })
      .addCase(GetStatesListByCountryCodeThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
          let country_code = action.meta.arg.country_code;
          let statesList = state.statesList;
          statesList[country_code] = data;

          if (data.length > 0) {
            state.statesList[country_code] = data;
            state.countryStatesList = data;
          }
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.statesLoading = false;
      })
      .addCase(GetStatesListByCountryCodeThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
      })
      .addCase(GetAudienceSegmentsListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAudienceSegmentsListThunk.fulfilled, (state, action) => {
        let resultData = action.payload.data;
        if (resultData?.error == false && resultData?.results?.length > 0) {
          let data = resultData.results[0];
          state.audienceSegmentsList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.loading = false;
      })
      .addCase(GetAudienceSegmentsListThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
      })
      .addCase(updateAudienceSegmentStatusThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateAudienceSegmentStatusThunk.fulfilled, (state, action) => {
        console.log("action", action.payload.data);
        // if (action.payload.data?.results?.length > 0) {
        //   let audienceSegmentsData = state.audienceSegmentsList;
        //   let id = action.meta.arg.id;
        //   let status = action.meta.arg.status;
        //   if (state.activeStatus == '-1') {
        //     audienceSegmentsData = audienceSegmentsData.map((item) => {
        //       if (item.id == id) {
        //         item.status = status
        //       }
        //       return item
        //     })
        //   } else {
        //     audienceSegmentsData = audienceSegmentsData.filter((el) => { return el.id != id; });
        //   }

        //   state.audienceSegmentsList = audienceSegmentsData;
        // } else if (action.payload.data.status == 0) {
        //   // toast.error(action.payload.data.message);
        // }
        state.loading = false;
      })
      .addCase(updateAudienceSegmentStatusThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
      })

      .addCase(CreateUpdateAudienceSegmentDetailsThunk.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(
        CreateUpdateAudienceSegmentDetailsThunk.fulfilled,
        (state, action) => {
          state.submitLoading = false;
        }
      )
      .addCase(
        CreateUpdateAudienceSegmentDetailsThunk.rejected,
        (state, action) => {
          state.submitLoading = false;
          //toast.error("Something went Wrong!");
        }
      )
      .addCase(CreateUpdateAudienceLocationDetailsThunk.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(
        CreateUpdateAudienceLocationDetailsThunk.fulfilled,
        (state, action) => {
          state.submitLoading = false;
        }
      )
      .addCase(
        CreateUpdateAudienceLocationDetailsThunk.rejected,
        (state, action) => {
          state.submitLoading = false;
        }
      )

      .addCase(GetAudienceSegmentDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAudienceSegmentDetailsThunk.fulfilled, (state, action) => {
        let resultData = action.payload.data;
        if (resultData?.error == false) {
          // state.audienceSegmentsList = resultData.results;
        }
        state.loading = false;
      })
      .addCase(GetAudienceSegmentDetailsThunk.rejected, (state, action) => {
        state.loading = false;
      })
      /*.addCase(GetAudienceTargetingsByIds.pending, (state) => {
        //state.loading = true;
        state.locationGroupLoading = true;
      })
      .addCase(GetAudienceTargetingsByIds.fulfilled, (state, action) => {
        //state.loading = false;
        state.locationGroupLoading = false;
      })
      .addCase(GetAudienceTargetingsByIds.rejected, (state, action) => {
        state.locationGroupLoading = false;
      })*/
      .addCase(GetAudienceLocationChildTablesDataThunk.pending, (state) => {
        //state.loading = true;
      })
      .addCase(
        GetAudienceLocationChildTablesDataThunk.fulfilled,
        (state, action) => {
          //state.loading = false;
        }
      )
      .addCase(
        GetAudienceLocationChildTablesDataThunk.rejected,
        (state, action) => {}
      )
      .addCase(UpdateAudienceStatusThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateAudienceStatusThunk.fulfilled, (state, action) => {
        if (action.payload.data?.error == false) {
          let audienceList = state.audienceSegmentsList;
          let audienceId = action.meta.arg.id;
          audienceList = audienceList.filter((item) => item.id !== audienceId);
          state.audienceSegmentsList = audienceList;
        }
        state.loading = false;
      })
      .addCase(UpdateAudienceStatusThunk.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(GetAllProviderListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllProviderListThunk.fulfilled, (state, action) => {
        if (
          action.payload.data?.error == false &&
          action.payload.data?.results?.length > 0
        ) {
          let data = action.payload.data.results[0];
          state.providerFlag = true;
          state.providersList = data;
          state.loading = false;
        }
      })
      .addCase(GetAllProviderListThunk.rejected, (state, action) => {})
      .addCase(CheckSegmentNameAvailabilityThunk.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(CheckSegmentNameAvailabilityThunk.fulfilled, (state, action) => {
        state.submitLoading = false;
      })
      .addCase(
        CheckSegmentNameAvailabilityThunk.rejected,
        (state, action) => {}
      )
      .addCase(GetContextualCategoriesListThunk.pending, (state) => {
        //state.searchLoading = true;
        //state.isCategoriesLoaded = false;
      })
      .addCase(GetContextualCategoriesListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];

          state.ContextualCategoriesList = data;
          state.contextualFlag = true;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        // state.isCategoriesLoaded = true;
        // state.searchLoading = false;
      })
      .addCase(GetContextualCategoriesListThunk.rejected, (state, action) => {
        // toast.error("Something went Wrong!");
      })
      .addCase(GetPoiItemUniquesThunk.pending, (state) => {
        //state.searchLoading = true;
        //state.isCategoriesLoaded = false;
      })
      .addCase(GetPoiItemUniquesThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
      })
      .addCase(GetPoiItemUniquesThunk.rejected, (state, action) => {
        // toast.error("Something went Wrong!");
      })
      .addCase(GetPoiItemDetailsByIDThunk.pending, (state) => {
        //state.searchLoading = true;
        //state.isCategoriesLoaded = false;
      })
      .addCase(GetPoiItemDetailsByIDThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
      })
      .addCase(GetPoiItemDetailsByIDThunk.rejected, (state, action) => {
        // toast.error("Something went Wrong!");
      })
      .addCase(getSegmentGeoHashInfo.pending, (state) => {})
      .addCase(getSegmentGeoHashInfo.fulfilled, (state, action) => {
        // if (action.payload.data?.results?.length > 0) {
        //   let data = action.payload.data.results[0];
        // } else if (action.payload.data.status == 0) {
        //   // toast.error(action.payload.data.message);
        // }
      })
      .addCase(getSegmentGeoHashInfo.rejected, (state, action) => {
        // toast.error("Something went Wrong!");
      });
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = AudienceManagement;
// Extract and export each action creator by name
export const {
  resetCountryDependencyList,
  resetPlacementsListData,
  updateSegmentFiltersFormValues,
  updateSegmentFilters,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
